webpackJsonp([1],{

/***/ "+SY6":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAZCAYAAAAbp/98AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAB5JREFUeNpiYKA5YNTR8W4AMViAuB7GaGSgDwAIMAD9LwItt0tTqAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "+Z2+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_diario.f66250c.png";

/***/ }),

/***/ "+jSN":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./CUIABA/rodapeLogo.png": "w/ji",
	"./DOE-AL/rodapeLogo.png": "8nuk",
	"./PMVG/rodapeLogo.png": "XDpy",
	"./TCE-AL/rodapeLogo.png": "g8fZ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+jSN";

/***/ }),

/***/ "/rQq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/wUI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_locale_pt_br__ = __webpack_require__("AoDM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_locale_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_locale_pt_br__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BuscaItemLegislacoes__ = __webpack_require__("1fPR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_portal__ = __webpack_require__("ENzL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main_js__ = __webpack_require__("NHnr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BuscaAvancada',
  components: {
    vSelect: __WEBPACK_IMPORTED_MODULE_2_vue_select___default.a,
    buscaItem: __WEBPACK_IMPORTED_MODULE_3__BuscaItemLegislacoes__["a" /* default */]
  },
  data: function data() {
    return {
      client: null,
      totalRows: 0,
      perPage: 15,
      currentPage: 1,
      min_date: '',
      max_date: '',
      items: [],
      tituloPagina: 'Pesquisar Legislações',
      tituloResultado: 'Resultados da Busca',
      showResults: false,
      showSearching: false,
      resultOffset: 0,
      resultKeywords: '',
      periodo_inicial: '',
      periodo_final: '',
      searchTypeOptions: [{ title: 'Todas as palavras', value: 'toda_palavra' }, { title: 'Frase exata', value: 'frase_exata' }, { title: 'Qualquer palavra', value: 'qualquer_palavra' }],
      orderOptions: [{ title: 'Mais antiga', value: 'antigo' }, { title: 'Mais nova', value: 'novo' }, { title: 'Por relevância', value: 'relevancia' }],
      formBusca: {
        keywords: '',
        range: [],
        legislation_number: '',
        searchType: {
          title: 'Frase exata',
          value: 'frase_exata'
        },
        order: {
          title: 'Mais nova',
          value: 'novo'
        }
      },
      filtroVeiculo: [],
      filtroVeiculoSelected: [],
      filtroTipoLegislacao: [],
      filtroTipoLegislacaoSelected: [],
      filtroAnoPublicacao: [],
      filtroAnoPublicacaoSelected: []
    };
  },
  created: function created() {
    var me = this;
    me.client = __WEBPACK_IMPORTED_MODULE_5__main_js__["default"].CLIENT;
    me.tituloRowBG = {
      backgroundImage: 'url(' + __webpack_require__("9wcz")("./" + me.client + '/tituloPagFdo.png') + ')'
    };
  },
  mounted: function mounted() {
    this.loadDataSearch();
  },

  methods: {
    loadDataSearch: function loadDataSearch() {
      var me = this;
      var searchData = this.$store.state.searchData;
      if (typeof searchData.palavra_chave === 'undefined') return false;
      me.formBusca.keywords = searchData.palavra_chave;
      me.periodo_inicial = searchData.periodo_inicial;
      me.periodo_final = searchData.periodo_final;
      me.formBusca.legislation_number = searchData.legislation_number;
      me.formBusca.searchType = searchData.searchType;
      me.formBusca.order = searchData.order;

      me.fetchLegislations();
      me.showResults = true;
      // limpando store
      me.$store.commit('populateSearch', null);
    },
    getResultTop: function getResultTop() {
      var resultArea = document.getElementById('areaResultados');
      this.resultOffset = resultArea.offsetTop;
    },
    scrollTop: function scrollTop() {
      var timeOut = void 0;
      var me = this;
      if (document.body.scrollTop > me.resultOffset || document.documentElement.scrollTop > me.resultOffset) {
        window.scrollBy(0, -30);
        timeOut = setTimeout(me.scrollTop, 10);
      } else clearTimeout(timeOut);
    },
    changePage: function changePage() {
      this.getResultTop();
      this.fetchLegislations(this.currentPage);
      this.scrollTop();
    },
    onSubmitBusca: function onSubmitBusca(evt) {
      this.currentPage = 1;
      this.showResults = false;
      evt.preventDefault();
      this.fetchLegislations();
    },
    fetchLegislations: function fetchLegislations() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      var me = this;

      me.showSearching = true;
      me.formBusca.range = [me.periodo_inicial, me.periodo_final];
      me.resultKeywords = me.formBusca.keywords;

      var dataBusca = {
        keywords: me.formBusca.keywords,
        range: me.formBusca.range,
        legislation_number: me.formBusca.legislation_number,
        searchType: '',
        order: ''
      };

      dataBusca.searchType = me.formBusca.searchType && me.formBusca.searchType.value ? me.formBusca.searchType.value : 'frase_exata';
      dataBusca.order = me.formBusca.order && me.formBusca.order.value ? me.formBusca.order.value : 'novo';

      if (me.filtroAnoPublicacaoSelected) {
        dataBusca.filter_year = me.filtroAnoPublicacaoSelected[0];
      }

      var promise = __WEBPACK_IMPORTED_MODULE_4__api_portal__["a" /* default */].searchLegislations(page, dataBusca);

      promise.then(function (data) {
        me.totalRows = data.total_rows.value;
        me.min_date = data.min_date;
        me.max_date = data.max_date;
        me.items = data.items;
        me.filtroAnoPublicacao = data.filter_year;
        me.filtroTipoLegislacao = data.filter_suplement;
        me.filtroVeiculo = data.filter_legislation_type;

        me.showResults = true;
        me.showSearching = false;
      });
    },
    onResetBusca: function onResetBusca(evt) {
      evt.preventDefault();
      /* Limpar os campos do formulario */
      this.formBusca.keywords = '';
      this.periodo_inicial = '';
      this.periodo_final = '';
      this.formBusca.legislation_number = '';
      this.formBusca.searchType = 'frase_exata';
      this.formBusca.order = 'novo';

      this.showResults = false;
      this.showSearching = false;
    },
    showMore: function showMore() {
      // console.log('showMore')
    }
  },
  filters: {
    formatDate: function formatDate(value) {
      if (value) {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(String(value)).format('LL');
      }
      return '-';
    }
  }
});

/***/ }),

/***/ "18lc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_portal__ = __webpack_require__("ENzL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main_js__ = __webpack_require__("NHnr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Destaque',
  data: function data() {
    return {
      client: null,
      tituloDestaque: '',
      descricaoDestaque: 'Visualize a \xFAltima edi\xE7\xE3o na \xEDntegra, clique no bot\xE3o abaixo para acess\xE1-la.',
      editionId: [],
      gazetaTopo: ''
    };
  },
  created: function created() {
    var me = this;
    me.fetchEditions();
    me.client = __WEBPACK_IMPORTED_MODULE_2__main_js__["default"].CLIENT;
    me.gazetaTopo = __webpack_require__("mF9N")("./" + me.client + '/gazetaTopo1.png');
    me.tituloDestaque = __WEBPACK_IMPORTED_MODULE_2__main_js__["default"].clientData.spotlight.title;
    me.descricaoDestaque = __WEBPACK_IMPORTED_MODULE_2__main_js__["default"].clientData.spotlight.description;
  },

  methods: {
    fetchEditions: function fetchEditions() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      var me = this;
      var promisse = __WEBPACK_IMPORTED_MODULE_1__api_portal__["a" /* default */].fetchEditions(page);
      promisse.then(function (items) {
        if (items.editions[0] !== undefined) me.editionId = items.editions[0].id;
      });
    },
    downloadEdition: function downloadEdition(editionId) {
      return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL + '/editions/downloadPdf/' + editionId;
    }
  },
  computed: {
    clientOpacity: function clientOpacity() {
      return this.client === 'DOE-AL' ? '1' : '0.95';
    }
  }
});

/***/ }),

/***/ "1fPR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuscaItemLegislacoes_vue__ = __webpack_require__("8S7e");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30fa9492_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuscaItemLegislacoes_vue__ = __webpack_require__("c/Cr");
function injectStyle (ssrContext) {
  __webpack_require__("ks4e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuscaItemLegislacoes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30fa9492_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuscaItemLegislacoes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1yyV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/diariobg.c3e159d.jpg";

/***/ }),

/***/ "3xPT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue__ = __webpack_require__("fy8N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_078b3c74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menu_vue__ = __webpack_require__("TRr2");
function injectStyle (ssrContext) {
  __webpack_require__("aAHW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_078b3c74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5+Mk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "75l9":
/***/ (function(module, exports) {

module.exports = {"_from":"axios@^0.21","_id":"axios@0.21.4","_inBundle":false,"_integrity":"sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==","_location":"/axios","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"axios@^0.21","name":"axios","escapedName":"axios","rawSpec":"^0.21","saveSpec":null,"fetchSpec":"^0.21"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/axios/-/axios-0.21.4.tgz","_shasum":"c67b90dc0568e5c1cf2b0b858c43ba28e2eda575","_spec":"axios@^0.21","_where":"/var/www/sites/gazeta/portal","author":{"name":"Matt Zabriskie"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"bugs":{"url":"https://github.com/axios/axios/issues"},"bundleDependencies":false,"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}],"dependencies":{"follow-redirects":"^1.14.0"},"deprecated":false,"description":"Promise based HTTP client for the browser and node.js","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"homepage":"https://axios-http.com","jsdelivr":"dist/axios.min.js","keywords":["xhr","http","ajax","promise","node"],"license":"MIT","main":"index.js","name":"axios","repository":{"type":"git","url":"git+https://github.com/axios/axios.git"},"scripts":{"build":"NODE_ENV=production grunt build","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","examples":"node ./examples/server.js","fix":"eslint --fix lib/**/*.js","postversion":"git push && git push --tags","preversion":"npm test","start":"node ./sandbox/server.js","test":"grunt test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"},"typings":"./index.d.ts","unpkg":"dist/axios.min.js","version":"0.21.4"}

/***/ }),

/***/ "8EO7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8P1f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_destaque_vue__ = __webpack_require__("18lc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13e90988_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_destaque_vue__ = __webpack_require__("KUpE");
function injectStyle (ssrContext) {
  __webpack_require__("iEnD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_destaque_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13e90988_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_destaque_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8S7e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_locale_pt_br__ = __webpack_require__("AoDM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_locale_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_locale_pt_br__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BuscaItem',
  props: {
    item: Object
  },
  data: function data() {
    return {};
  },

  methods: {
    downloadLegislation: function downloadLegislation(legislationId) {
      return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL + '/legislations/downloadPdf/' + legislationId;
    },
    downloadPage: function downloadPage(legislationId, pageNumber) {
      return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL + '/legislations/viewPdf/' + legislationId + '#page=' + pageNumber;
    }
  },
  filters: {
    formatDate: function formatDate(value) {
      if (value) {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(String(value)).format('LL');
      }

      return '-';
    },
    formatHL: function formatHL(value) {
      var ret = value[0].replace('<em>', '<strong>').replace('<\\/em>', '</strong>');
      return ret;
    }
  }
});

/***/ }),

/***/ "8nuk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rodapeLogo.6d32b08.png";

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9wcz":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./CUIABA/tituloPagFdo.png": "uYzE",
	"./DOE-AL/tituloPagFdo.png": "xSFO",
	"./PMVG/tituloPagFdo.png": "+SY6",
	"./TCE-AL/tituloPagFdo.png": "vwlZ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9wcz";

/***/ }),

/***/ "BdKI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C73V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicarDiarioOficial_vue__ = __webpack_require__("Fy5s");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aebfba98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicarDiarioOficial_vue__ = __webpack_require__("jpNI");
function injectStyle (ssrContext) {
  __webpack_require__("5+Mk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicarDiarioOficial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aebfba98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicarDiarioOficial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CG5S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CIJu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"legislations-page"}},[_c('b-row',{staticClass:"tituloPaginaRow",style:(_vm.tituloRowBG)},[_c('h1',{staticClass:"tituloPagina text-center tituloIntro"},[_vm._v("\n      "+_vm._s(_vm.tituloPagina)+"\n    ")])]),_vm._v(" "),_c('b-row',{staticClass:"p-3 p-sm-0"},[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{attrs:{"id":"arvore"}},[_c('div',{attrs:{"id":"decades-row"}},[_c('div',{attrs:{"id":"decades"}},_vm._l((_vm.decades),function(decade,index){return _c('div',{key:index},[_c('b-button',{staticClass:"periodButton",class:decade.activeMenu ? 'menu-active' : '',attrs:{"type":"button","variant":"cinzaClaro","id":decade.id},on:{"click":function($event){return _vm.loadYears(decade)}}},[_vm._v(_vm._s(decade.title))])],1)}),0)]),_vm._v(" "),_c('div',{attrs:{"id":"years-row"}},[_c('div',{attrs:{"id":"years"}},_vm._l((_vm.years),function(year,index){return _c('div',{key:index},[_c('b-button',{staticClass:"periodButton",class:year.activeMenu ? 'menu-active' : '',attrs:{"type":"button","variant":"cinzaClaro","id":year.id},on:{"click":function($event){return _vm.loadMonths(year)}}},[_vm._v("Ano "+_vm._s(year.title))])],1)}),0)]),_vm._v(" "),_c('div',{attrs:{"id":"months-row"}},[_c('div',{attrs:{"id":"months"}},_vm._l((_vm.months),function(month,index){return _c('div',{key:index},[_c('b-button',{staticClass:"periodButton",class:month.activeMenu ? 'menu-active' : '',attrs:{"type":"button","variant":"cinzaClaro","id":month.id,"name":"button"},on:{"click":function($event){return _vm.loadLegislations(month, index)}}},[_vm._v(_vm._s(month.title))])],1)}),0)]),_vm._v(" "),_c('div',{attrs:{"id":"types-row"}},[_c('div',{attrs:{"id":"types"}},[_vm._l((_vm.types),function(type,index){return _c('div',{key:index},[_c('b-button',{class:type.activeMenu ? 'menu-active' : '',attrs:{"type":"button","variant":"cinzaClaro","id":type.id,"name":"button"},on:{"click":function($event){return _vm.loadType(type, true)}}},[_vm._v(_vm._s(type.title))])],1)}),_vm._v(" "),(_vm.typeSelected)?[_c('div',[_c('b-button',{attrs:{"type":"button","variant":"cinzaClaro","name":"button"},on:{"click":function($event){return _vm.resetTypes()}}},[_c('icon',{attrs:{"name":"times"}}),_vm._v("  Limpar\n                ")],1)],1)]:_vm._e()],2)])])])],1),_vm._v(" "),_c('b-row',{staticClass:"text-center"},[_c('b-col',{staticClass:"mt-sm-2 mb-sm-8",attrs:{"cols":"12","sm":"12","md":"12","lg":"12","xl":"12"}},[(_vm.legislationsLoaded && !_vm.legislationIsLoading)?[(_vm.items.length)?[_c('div',{staticClass:"tipo-legislations"},[_c('strong',[_vm._v("Mês Selecionado:\n              "),_c('i',{staticClass:"themecolor"},[_vm._v(_vm._s(_vm.activeMonthName)+" de "+_vm._s(_vm.activeYearName))])]),_vm._v(" "),(_vm.typeSelected)?[_c('br'),_vm._v(" "),_c('strong',[_vm._v("Tipo Selecionado:\n                "),_c('i',{staticClass:"themecolor"},[_vm._v(_vm._s(_vm.activeTypeName))])])]:_vm._e()],2),_vm._v(" "),_c('h4',{staticClass:"text-center mt-4"},[_vm._v("Publicações")]),_vm._v(" "),_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.items,"fields":_vm.fields,"per-page":_vm.perPage,"id":"tableLegislations"},scopedSlots:_vm._u([{key:"cell(type)",fn:function(data){return [_vm._v("\n              "+_vm._s(data.item['type'])+" "+_vm._s(data.item['number'])+"\n            ")]}},{key:"cell(publication_date)",fn:function(data){return [_vm._v("\n              "+_vm._s(_vm._f("formatDate")(data.item['publication_date']))+"\n            ")]}},{key:"cell(epigrafe)",fn:function(data){return [_vm._v("\n              "+_vm._s(_vm._f("formatEpigrafe")(data.item['epigrafe']))+"\n            ")]}},{key:"cell(downloads)",fn:function(data){return [_vm._v("\n              "+_vm._s(_vm._f("formatViews")(data.item['downloads']))+"\n            ")]}},{key:"cell(acoes)",fn:function(data){return [_c('b-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"target":"_blank","href":_vm.viewLegislation(data.item.edition.id, data.item.page),"title":"Ver legislação"}},[_c('icon',{attrs:{"name":"eye"}})],1),_vm._v(" "),_c('b-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"href":_vm.downloadLegislation(data.item.edition.id),"title":"Baixar legislação"}},[_c('icon',{attrs:{"name":"download"}})],1)]}}],null,false,2991027769)}),_vm._v(" "),_c('nav',[_c('b-pagination',{staticClass:"d-inline-flex",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage,"prev-text":"Anterior","next-text":"Próximo","hide-goto-end-buttons":""},on:{"input":_vm.changePage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)]:_c('div',{staticClass:"message"},[_c('strong',[_vm._v("Não existem legislações publicadas nesse mês, por favor selecione\n            outra data.")])])]:(_vm.legislationIsLoading)?[_c('div',{staticClass:"message"},[_c('strong',[_vm._v("\n            Carregando listagem\n            "),_c('icon',{attrs:{"name":"spinner","spin":""}})],1)])]:[_c('div',{staticClass:"message"},[_c('strong',[_vm._v("Selecione acima a data da legislação para a exibição da\n            listagem")])])]],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Co5Y":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/homeDiarioBusca.9b734f4.png";

/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("dXrS");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("sHGW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D7CY":
/***/ (function(module, exports) {

module.exports = {"name":"Diário Oficial - Prefeitura Municipal de Várzea Grande","titleMobile":"Diário Oficial","home":{"title":"Diário Oficial"},"spotlight":{"title":"Confira a última edição do Diário Oficial","description":"Visualize a última edição na íntegra, clique no botão abaixo para acessá-la."},"about":{"title":"Sobre o Diário Oficial","text":"","contactText":"Entre em contato com a Prefeitura, preencha o formulário abaixo:"},"footer":{"footerTitle":"Prefeitura Municipal de Várzea Grande","footerDescription":"<b>Telefone:</b> (65) 3688-8000 (Recepção)<br><b>Horário de Funcionamento:</b> 08h às 18h <br>Av. Castelo Branco, 2500 - Centro Sul, Várzea Grande - MT 78125-700","footerLogoTitle":"PMVG Prefeitura Municipal de Várzea Grande","footerLink":"http://www.varzeagrande.mt.gov.br/"},"layout":{"corPrimaria":" #016505","corPrimariaClara":"#0b8f01","corSecundaria":"#E96C66 ","corRodape":"#8a2224","corBordaRodape":"#8a2224"}}

/***/ }),

/***/ "DYLJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Legislacoes_vue__ = __webpack_require__("OrFs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6de1033e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Legislacoes_vue__ = __webpack_require__("CIJu");
function injectStyle (ssrContext) {
  __webpack_require__("/rQq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Legislacoes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6de1033e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Legislacoes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DnHs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ENzL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

/**
 * API do Portal
 */


var fetchEditions = function fetchEditions(page) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('editions/published?page=' + page).then(function (response) {
    return response.data;
  });
};

var fetchSelectedEditions = function fetchSelectedEditions(year, month) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('editions/published/' + year + '/' + month).then(function (response) {
    return response.data;
  });
};

var fetchLegislations = function fetchLegislations(page) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('legislations/published?page=' + page).then(function (response) {
    return response.data;
  });
};

var fetchSelectedLegislations = function fetchSelectedLegislations(year, month, page, perPage) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('legislations/published/' + year + '/' + month + '?page=' + page + '&perPage=' + perPage).then(function (response) {
    return response.data;
  });
};

var fetchSelectedLegislationsByType = function fetchSelectedLegislationsByType(year, month, type, page, perPage) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('legislations/published/' + year + '/' + month + '/' + type + '?page=' + page + '&perPage=' + perPage).then(function (response) {
    return response.data;
  });
};

var fetchPublishPortal = function fetchPublishPortal(body) {
  var parsedValues = {
    pessoaTipo: 'kind_person',
    nome: 'full_name',
    cep: 'zip_code',
    endereco: 'street_address',
    cpf: 'cpf',
    cnpj: 'cnpj',
    numero: 'number',
    telefone: 'phone',
    complemento: 'complement',
    email: 'mail',
    bairro: 'neighborhood',
    cidade: 'city',
    uf: 'state',
    arquivos: 'file'
  };

  var formData = new FormData();
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(body).forEach(function (element) {
    if (body[element]) {
      formData.append(parsedValues[element], body[element]);
    }
  });

  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('mail/send', formData, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(function (response) {
    return response.data;
  });
};

var searchEditions = function searchEditions(page, data) {
  var _this = this;

  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('editions/searchES?page=' + page, data).then(function (response) {
    _this.filter_year = response.data.result.aggregations.year.buckets.map(function (item) {
      return {
        text: item.key + ' (' + item.doc_count + ') ',
        value: item.key
      };
    });

    _this.filter_edition_type = response.data.result.aggregations.edition_type_name.buckets.map(function (item) {
      return {
        text: item.key + ' (' + item.doc_count + ') ',
        value: item.key
      };
    });

    _this.filter_suplement = response.data.result.aggregations.suplement.buckets.map(function (item) {
      return {
        text: (item.key === 0 ? 'Normal' : 'Suplemento') + ' (' + item.doc_count + ') ',
        value: item.key_as_string
      };
    });

    return {
      items: response.data.result.items,
      filter_year: _this.filter_year,
      filter_edition_type: _this.filter_edition_type,
      filter_suplement: _this.filter_suplement,
      total_rows: response.data.result.total_rows,
      max_date: response.data.result.aggregations.max_date.value_as_string,
      min_date: response.data.result.aggregations.min_date.value_as_string
    };
  });
};

var searchLegislations = function searchLegislations(page, data) {
  var _this2 = this;

  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('legislations/searchES?page=' + page, data).then(function (response) {
    _this2.filter_year = response.data.result.aggregations.year.buckets.map(function (item) {
      return {
        text: item.key + ' (' + item.doc_count + ') ',
        value: item.key
      };
    });

    _this2.filter_edition_type = response.data.result.aggregations.edition_type_name.buckets.map(function (item) {
      return {
        text: item.key + ' (' + item.doc_count + ') ',
        value: item.key
      };
    });

    _this2.filter_suplement = response.data.result.aggregations.suplement.buckets.map(function (item) {
      return {
        text: (item.key === 0 ? 'Normal' : 'Suplemento') + ' (' + item.doc_count + ') ',
        value: item.key_as_string
      };
    });

    return {
      items: response.data.result.items,
      filter_year: _this2.filter_year,
      filter_edition_type: _this2.filter_edition_type,
      filter_suplement: _this2.filter_suplement,
      total_rows: response.data.result.total_rows,
      max_date: response.data.result.aggregations.max_date.value_as_string,
      min_date: response.data.result.aggregations.min_date.value_as_string
    };
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchEditions: fetchEditions,
  fetchSelectedEditions: fetchSelectedEditions,
  fetchLegislations: fetchLegislations,
  fetchSelectedLegislations: fetchSelectedLegislations,
  fetchSelectedLegislationsByType: fetchSelectedLegislationsByType,
  fetchPublishPortal: fetchPublishPortal,
  searchEditions: searchEditions,
  searchLegislations: searchLegislations
});

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_locale_pt_br__ = __webpack_require__("AoDM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_locale_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_locale_pt_br__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_portal__ = __webpack_require__("ENzL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main_js__ = __webpack_require__("NHnr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    vSelect: __WEBPACK_IMPORTED_MODULE_3_vue_select___default.a
  },
  data: function data() {
    return {
      client: null,
      perPage: 5,
      tituloPagina: '',
      tituloBusca: 'Pesquisar Edições',
      tituloRowBG: '',
      searchTypeOptions: [{ title: 'Todas as palavras', value: 'toda_palavra' }, { title: 'Frase exata', value: 'frase_exata' }, { title: 'Qualquer palavra', value: 'qualquer_palavra' }],
      orderOptions: [{ title: 'Mais antiga', value: 'antigo' }, { title: 'Mais nova', value: 'novo' }, { title: 'Por relevância', value: 'relevancia' }],
      formBusca: {
        palavra_chave: '',
        periodo_inicial: '',
        periodo_final: '',
        edition_number: '',
        searchType: {
          title: 'Frase exata',
          value: 'frase_exata'
        },
        order: {
          title: 'Mais nova',
          value: 'novo'
        }
      },
      fields: [{
        key: 'number',
        label: 'Edição',
        sortable: false,
        class: 'number'
      }, {
        key: 'publication_date',
        label: 'Data da publicação',
        sortable: false,
        class: 'date'
      }, {
        key: 'acoes',
        label: 'Ações',
        class: 'text-center actions'
      }],
      items: []
    };
  },
  created: function created() {
    var me = this;
    me.fetchEditions();
    me.client = __WEBPACK_IMPORTED_MODULE_5__main_js__["default"].CLIENT;
    me.tituloPagina = __WEBPACK_IMPORTED_MODULE_5__main_js__["default"].clientData.home.title;
    me.tituloRowBG = {
      backgroundImage: 'url(' + __webpack_require__("9wcz")("./" + me.client + '/tituloPagFdo.png') + ')'
    };
  },

  methods: {
    fetchEditions: function fetchEditions() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      var me = this;
      var promisse = __WEBPACK_IMPORTED_MODULE_4__api_portal__["a" /* default */].fetchEditions(page);
      promisse.then(function (items) {
        me.items = items.editions;
      });
    },
    viewEdition: function viewEdition(editionId) {
      return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL + '/editions/viewPdf/' + editionId;
    },
    downloadEdition: function downloadEdition(editionId) {
      return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL + '/editions/downloadPdf/' + editionId;
    },
    onSubmitBusca: function onSubmitBusca(evt) {
      var me = this;
      evt.preventDefault();
      me.$store.commit('populateSearch', me.formBusca);
      me.$router.push('/busca');
    },
    onResetBusca: function onResetBusca(evt) {
      var _this = this;

      evt.preventDefault();
      /* Limpar os campos do formulario */
      this.formBusca.palavra_chave = '';
      this.formBusca.periodo_inicial = '';
      this.formBusca.periodo_final = '';
      this.formBusca.edition_number = '';
      /* Trick to reset/clear native browser form validation state */
      this.showBusca = false;
      this.$nextTick(function () {
        _this.showBusca = true;
      });
    }
  },
  filters: {
    formatDate: function formatDate(value) {
      if (value) {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(String(value)).format('LL');
      }
      return '-';
    },
    formatSuplement: function formatSuplement(value) {
      if (value === 1 || value === '1') {
        return ' - Suplemento';
      }
      return '';
    }
  }
});

/***/ }),

/***/ "Fy5s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_portal__ = __webpack_require__("ENzL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_js__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_cpf_cnpj_validator__ = __webpack_require__("428a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var validCEP = function validCEP(value, vm) {
  return vm.validCEP === true;
};
var validCPF = function validCPF(value, vm) {
  if (value.length === 14 && __WEBPACK_IMPORTED_MODULE_5_cpf_cnpj_validator__["a" /* cpf */].isValid(value) || vm.pessoaTipo === 'Jurídica') {
    return true;
  }
  return false;
};
var validCNPJ = function validCNPJ(value, vm) {
  if (value.length === 18 && __WEBPACK_IMPORTED_MODULE_5_cpf_cnpj_validator__["b" /* cnpj */].isValid(value) || vm.pessoaTipo !== 'Jurídica') {
    return true;
  }
  return false;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      adminUrl: '',
      client: null,
      tituloPagina: '',
      tituloRowBG: '',
      textoSobre: '',
      tituloContato: '',
      formulario: {
        nome: '',
        cep: '',
        endereco: '',
        cpf: '',
        cnpj: '',
        numero: '',
        telefone: '',
        complemento: '',
        email: '',
        bairro: '',
        cidade: '',
        uf: '',
        arquivos: null,
        pessoaTipo: 'Física',
        validCEP: false
      },
      tipoPessoa: ['Física', 'Jurídica'],
      fileState: true,
      formStatus: null,
      formResponseMsg: ''
    };
  },

  directives: { mask: __WEBPACK_IMPORTED_MODULE_2_vue_the_mask__["mask"] },
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vuelidate__["validationMixin"]],
  components: {
    vSelect: __WEBPACK_IMPORTED_MODULE_3_vue_select___default.a
  },
  validations: {
    formulario: {
      nome: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["minLength"])(3)
      },
      cep: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["minLength"])(9),
        validCEP: validCEP
      },
      endereco: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
      },
      cpf: {
        required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["requiredIf"])(function () {
          return this.formulario.pessoaTipo !== 'Jurídica';
        }),
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["requiredIf"])(function () {
          if (this.formulario.pessoaTipo === 'Jurídica') {
            return false;
          } else {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["minLength"])(14);
          }
        }),
        validCPF: validCPF
      },
      cnpj: {
        required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["requiredIf"])(function () {
          return this.formulario.pessoaTipo === 'Jurídica';
        }),
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["requiredIf"])(function () {
          if (this.formulario.pessoaTipo !== 'Jurídica') {
            return false;
          } else {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["minLength"])(18);
          }
        }),
        validCNPJ: validCNPJ
      },
      numero: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
      },
      telefone: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["minLength"])(13)
      },
      email: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"],
        email: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["email"]
      },
      bairro: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
      },
      cidade: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
      },
      uf: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
      },
      arquivos: {
        required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["requiredIf"])(function () {
          return !this.formulario.arquivos;
        })
      },
      pessoaTipo: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
      }
    }
  },
  created: function created() {
    var me = this;
    me.adminUrl = __WEBPACK_IMPORTED_MODULE_1__main_js__["default"].adminUrl;
    me.client = __WEBPACK_IMPORTED_MODULE_1__main_js__["default"].CLIENT;
    me.tituloPagina = __WEBPACK_IMPORTED_MODULE_1__main_js__["default"].clientData.about.title;
    me.textoSobre = __WEBPACK_IMPORTED_MODULE_1__main_js__["default"].clientData.about.text;
    me.tituloContato = __WEBPACK_IMPORTED_MODULE_1__main_js__["default"].clientData.about.contactText;
    me.tituloRowBG = {
      backgroundImage: 'url(' + __webpack_require__("9wcz")("./" + me.client + '/tituloPagFdo.png') + ')'
    };
  },

  methods: {
    scrollIntoMessage: function scrollIntoMessage(formStatus) {
      if (formStatus) {
        this.formStatus = formStatus;
      }

      if (document.getElementById('status-message-text')) {
        document.getElementById('status-message-text').scrollIntoView({ behavior: 'smooth' });
      }
    },
    resetForm: function resetForm() {
      var form = {
        nome: '',
        cep: '',
        endereco: '',
        cpf: '',
        cnpj: '',
        numero: '',
        telefone: '',
        complemento: '',
        email: '',
        bairro: '',
        cidade: '',
        uf: '',
        arquivos: null,
        pessoaTipo: 'Física',
        validCEP: false
      };
      this.formulario = form;
    },
    sendForm: function sendForm() {
      var me = this;
      var formulario = me.$v.formulario;
      me.formResponseMsg = '';
      formulario.$touch();

      if (formulario.$invalid) {
        me.scrollIntoMessage('ERROR');
      } else {
        me.scrollIntoMessage('PENDING');

        var promisse = __WEBPACK_IMPORTED_MODULE_0__api_portal__["a" /* default */].fetchPublishPortal(this.formulario);
        promisse.then(function () {
          me.scrollIntoMessage('OK');
        }, function (error) {
          me.scrollIntoMessage('ERROR-API');

          if (error.response && error.response.data) {
            var message = error.response.data.message;

            me.formResponseMsg = message;
          }
        });
      }
    },
    getCep: function getCep() {
      var me = this;
      var baseCep = 'https://viacep.com.br/ws/';
      var cep = this.formulario.cep.replace('-', '');
      var url = '' + baseCep + cep + '/json/';
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url).then(function (resp) {
        var data = resp.data;
        if (!data.erro) {
          me.formulario.validCEP = true;
          me.formulario.bairro = data.bairro;
          me.formulario.cidade = data.localidade;
          me.formulario.endereco = data.logradouro;
          me.formulario.uf = data.uf;
        } else {
          me.formulario.validCEP = false;
          me.cleanCepData();
        }
      });
    },
    cleanCepData: function cleanCepData() {
      var me = this;
      me.formulario.bairro = '';
      me.formulario.cidade = '';
      me.formulario.endereco = '';
      me.formulario.uf = '';
    },
    inputState: function inputState(field) {
      if (!field.$dirty) {
        // field.$touch() // validar todos os campos ao abrir form
        return null;
      }
      return !field.$error;
    },
    togglePersonType: function togglePersonType() {
      var me = this;
      me.formulario.cpf = '';
      me.formulario.cnpj = '';
    }
  },
  computed: {
    testFiles: function testFiles() {
      return this.formulario.arquivos;
    },
    testCep: function testCep() {
      return this.formulario.cep;
    }
  },
  watch: {
    testFiles: function testFiles(val) {
      var me = this;
      if (!val || !val.name) return null;
      var name = val.name;
      if (name.includes('.doc') || name.includes('.docx')) {
        me.fileState = true;
        return val;
      } else {
        me.fileState = false;
        me.formulario.arquivos = null;
        return null;
      }
    },
    testCep: function testCep(novoCep) {
      if (novoCep.length === 9) this.getCep();else this.cleanCepData();
    }
  }
});

/***/ }),

/***/ "GxUR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuscaLegislacoes_vue__ = __webpack_require__("/wUI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_803d6f6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuscaLegislacoes_vue__ = __webpack_require__("M9va");
function injectStyle (ssrContext) {
  __webpack_require__("BdKI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuscaLegislacoes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_803d6f6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuscaLegislacoes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HqUf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/diariobg.1ba36a7.jpg";

/***/ }),

/***/ "IA//":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-item block"},[_c('b-row',{staticClass:"mx-auto"},[_c('h6',[_vm._v("\n      "+_vm._s(_vm.item.edition_type_name)+" № "+_vm._s(_vm.item.edition_number)+" - Página\n      "+_vm._s(_vm.item.page_number)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"item-actions"},[(_vm.pdfJsExpressKey)?_c('b-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"d-inline",attrs:{"href":"#loadPDF","title":"Acessar página encontrada"},on:{"click":function($event){$event.preventDefault();return _vm.preparePDF(_vm.item.edition_id, _vm.item.page_number)}}},[_c('icon',{attrs:{"name":"file-pdf"}}),_vm._v(" "),_c('span',[_vm._v(" Página Encontrada ")])],1):_c('b-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"d-inline",attrs:{"target":"_blank","href":_vm.downloadPage(_vm.item.edition_id, _vm.item.page_number),"title":"Baixar página encontrada"}},[_c('icon',{attrs:{"name":"download"}}),_vm._v(" "),_c('span',[_vm._v(" Página Encontrada ")])],1),_vm._v("\n       \n      "),_c('b-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"d-inline",attrs:{"href":_vm.downloadEdition(_vm.item.edition_id),"title":"Baixar edição"}},[_c('icon',{attrs:{"name":"download"}}),_vm._v(" "),_c('span',[_vm._v(" Edição Completa ")])],1)],1)]),_vm._v(" "),_c('b-row',{staticClass:"mx-auto mb-2"},[_c('span',{staticClass:"item-data"},[_vm._v(" "+_vm._s(_vm._f("formatDate")(_vm.item.publication_date)))])]),_vm._v(" "),_c('b-row',{staticClass:"mx-auto"},[_c('p',{staticClass:"item-result",domProps:{"innerHTML":_vm._s(
        _vm.item.highlight[0]
          .replace(/<em>/g, '<strong>')
          .replace(/<\\\/em>/g, '</strong>')
      )}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__("ukYY");




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* state */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* mutations */]
}));

/***/ }),

/***/ "JYW+":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./DOE-AL/logo_diario.png": "+Z2+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JYW+";

/***/ }),

/***/ "JeC3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_vue__ = __webpack_require__("3xPT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__destaque_vue__ = __webpack_require__("8P1f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main_js__ = __webpack_require__("NHnr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Topo',
  data: function data() {
    return {
      client: null,
      fundoTopo: ''
    };
  },
  created: function created() {
    var me = this;
    me.client = __WEBPACK_IMPORTED_MODULE_2__main_js__["default"].CLIENT;
    if (me.client === 'CUIABA' || me.client === 'DOE-AL') {
      me.fundoTopo = { background: '#fff' };
    } else {
      me.fundoTopo = {
        backgroundImage: 'url(' + __webpack_require__("YKlk")("./" + me.client + '/diariobg.jpg') + ')'
      };
    }
  },

  components: {
    menuSite: __WEBPACK_IMPORTED_MODULE_0__menu_vue__["a" /* default */],
    destaque: __WEBPACK_IMPORTED_MODULE_1__destaque_vue__["a" /* default */]
  },
  computed: {
    baseLink: function baseLink() {
      var link = __WEBPACK_IMPORTED_MODULE_2__main_js__["default"].APP_ENVIROMENT === 'prod' ? '/sispub' : '/admin';
      return link;
    }
  }
});

/***/ }),

/***/ "Jh4b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/diariobg.965cf50.jpg";

/***/ }),

/***/ "Jpem":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ fontFamily: _vm.clientFont }),attrs:{"id":"app"}},[_c('topo'),_vm._v(" "),_c('b-container',{attrs:{"id":"corpo-site"}},[_c('router-view')],1),_vm._v(" "),_c('rodape')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KUpE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ opacity: _vm.clientOpacity }),attrs:{"id":"destaque"}},[_c('b-container',{attrs:{"id":"conteudoDestaque"}},[(_vm.$route.name === 'Home')?_c('b-row',{attrs:{"id":"destaqueGrande"}},[_c('b-col',{staticClass:"text-center",attrs:{"sm":"12","lg":"4"}},[_c('a',{attrs:{"id":"ultimaEdicao","href":_vm.downloadEdition(_vm.editionId)}},[_c('img',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.righttop",modifiers:{"hover":true,"righttop":true}}],staticClass:"imgHover img-fluid",attrs:{"src":_vm.gazetaTopo,"title":"Veja a última edição do diário","alt":"Veja a última edição do diário"}})]),_vm._v(" "),_c('div',{staticClass:"efeitoMultiply img-fluid"})]),_vm._v(" "),_c('b-col',{staticClass:"pt-lg-4 pb-sm-4",attrs:{"sm":"12","lg":"8"}},[_c('h3',{staticClass:"mt-sm-5 mt-lg-5"},[_vm._v(_vm._s(_vm.tituloDestaque))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.descricaoDestaque)}}),_vm._v(" "),_c('b-button',{staticClass:"botaoDestaque d-table mb-4 mb-sm-0 mb-md-0 mb-lg-0 mb-xl-0",attrs:{"href":_vm.downloadEdition(_vm.editionId)}},[_vm._v("\n          ver edição\n        ")])],1)],1):_c('b-row',{attrs:{"id":"destaqueReduzido"}},[_c('b-col',{staticClass:"pt-4 pt-lg-3",attrs:{"cols":"12","sm":"12","md":"12","lg":"7","xl":"7","offset-lg":"1","offset-xl":"1"}},[_c('h3',[_vm._v(_vm._s(_vm.tituloDestaque))]),_vm._v(" "),_c('p',{staticClass:"mb-0 mb-lg-3",domProps:{"innerHTML":_vm._s(_vm.descricaoDestaque)}})]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"4","xl":"4"}},[_c('b-button',{staticClass:"botaoDestaque d-table mb-4 mb-md-0",attrs:{"href":_vm.downloadEdition(_vm.editionId)}},[_vm._v("\n          ver edição\n        ")])],1)],1)],1),_vm._v(" "),_c('b-container',{attrs:{"fluid":"","id":"barraSecundaria"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b7daade_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Jpem");
function injectStyle (ssrContext) {
  __webpack_require__("d9C8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b7daade_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M9va":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"tituloPaginaRow",style:(_vm.tituloRowBG)},[_c('h1',{staticClass:"tituloPagina"},[_vm._v("\n      "+_vm._s(_vm.tituloPagina)+"\n    ")])]),_vm._v(" "),_c('b-row',{staticClass:"p-3 p-sm-0 p-md-0 p-lg-0 p-xl-0"},[_c('b-form',{staticClass:"mb-0",attrs:{"id":"formBusca"},on:{"submit":_vm.onSubmitBusca,"reset":_vm.onResetBusca}},[_c('p',[_vm._v("\n        Busque as legislações publicadas com o critério desejado preenchendo\n        os campos abaixo.\n      ")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"d-sm-inline-block d-md-none px-4 text-center",attrs:{"cols":"12"}},[_c('img',{staticClass:"w-75",attrs:{"src":__webpack_require__("Co5Y"),"alt":"Imagem de busca nas edições"}})]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","md":"10"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"id":"inputGrupoPalavraChave"}},[_c('b-form-input',{attrs:{"id":"inputPalavraChave","type":"text","placeholder":"Buscar por: (Qualquer palavra...)"},model:{value:(_vm.formBusca.keywords),callback:function ($$v) {_vm.$set(_vm.formBusca, "keywords", $$v)},expression:"formBusca.keywords"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"inputGrupoPeriodoInicial","label":"Período inicial:","label-for":"inputPeriodoInicial"}},[_c('b-form-input',{attrs:{"id":"inputPeriodoInicial","type":"date","placeholder":"Período inicial ..."},model:{value:(_vm.periodo_inicial),callback:function ($$v) {_vm.periodo_inicial=$$v},expression:"periodo_inicial"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"id":"inputGrupoPeriodoFinal","label":"Período final:","label-for":"inputPeriodoFinal"}},[_c('b-form-input',{attrs:{"id":"inputPeriodoFinal","type":"date","placeholder":"Período final ..."},model:{value:(_vm.periodo_final),callback:function ($$v) {_vm.periodo_final=$$v},expression:"periodo_final"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"id":"inputGrupoNumeroEdicao","label":"Número da Legislação:","label-for":"inputNumeroEdicao"}},[_c('b-form-input',{attrs:{"id":"inputNumeroEdicao","type":"text","placeholder":"Legislação Nº..."},model:{value:(_vm.formBusca.legislation_number),callback:function ($$v) {_vm.$set(_vm.formBusca, "legislation_number", $$v)},expression:"formBusca.legislation_number"}})],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"d-none d-md-inline-block pt-2",attrs:{"cols":"12","sm":"2","md":"2","lg":"2","xl":"2"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("Co5Y"),"alt":"Imagem de busca nas legislações"}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"5"}},[_c('b-form-group',{attrs:{"id":"selectGrupoBuscaTipo","label":"Buscar por:","label-for":"selectBuscaTipo"}},[_c('v-select',{attrs:{"id":"selectBuscaTipo","placeholder":"Selecione o tipo da busca","label":"title","options":_vm.searchTypeOptions},model:{value:(_vm.formBusca.searchType),callback:function ($$v) {_vm.$set(_vm.formBusca, "searchType", $$v)},expression:"formBusca.searchType"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"5"}},[_c('b-form-group',{attrs:{"id":"selectGrupoOrdenacao","label":"Ordenar por:","label-for":"selectOrdenacao"}},[_c('v-select',{attrs:{"id":"selectOrdenacao","placeholder":"Selecione a ordenação da busca","label":"title","options":_vm.orderOptions},model:{value:(_vm.formBusca.order),callback:function ($$v) {_vm.$set(_vm.formBusca, "order", $$v)},expression:"formBusca.order"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"pt-4 pl-0",attrs:{"cols":"12","sm":"10"}},[_c('b-form-group',{staticClass:"float-right"},[_c('b-button',{staticClass:"mt-2 mr-1",attrs:{"type":"reset","variant":"cinzaClaro"}},[_vm._v("Limpar")]),_vm._v(" "),_c('b-button',{staticClass:"mt-2",attrs:{"type":"submit","variant":"primary"}},[_vm._v("Buscar")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"pt-4 pl-0 d-none d-sm-inline-block",attrs:{"cols":"2"}})],1)],1)],1)],1)],1),_vm._v(" "),[_c('transition',{attrs:{"name":"fade","mode":"in-out"}},[_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearching),expression:"showSearching"}],staticClass:"mt-4",staticStyle:{"height":"100vh"}},[_c('b-col',{attrs:{"cols":"12"}},[_c('h1',{staticClass:"tituloPagina"},[_vm._v("\n            Buscando por\n            "),_c('span',{staticClass:"palavraResultado"},[_vm._v(_vm._s(_vm.resultKeywords))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.periodo_inicial),expression:"periodo_inicial"}]},[_vm._v("\n              no período de\n              "),_c('strong',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.periodo_inicial)))])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.periodo_final),expression:"periodo_final"}]},[_vm._v("\n              até "),_c('strong',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.periodo_final)))])]),_vm._v("...\n          ")])])],1)],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"in-out"}},[_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.showResults),expression:"showResults"}],staticClass:"mt-4 tituloPaginaRow",style:(_vm.tituloRowBG),attrs:{"id":"areaResultados"}},[_c('h1',{staticClass:"tituloPagina"},[_vm._v("\n          "+_vm._s(_vm.tituloResultado)+"\n        ")])])],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"in-out"}},[_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.showResults),expression:"showResults"}],staticClass:"p-3 p-sm-0 p-md-0 p-lg-0 p-xl-0"},[_c('p',[_vm._v("\n          Exibindo "),_c('strong',[_vm._v(_vm._s(_vm.totalRows))]),_vm._v(" resultados para a consulta\n          "),_c('span',{staticClass:"palavraResultado"},[_vm._v(_vm._s(_vm.resultKeywords))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.periodo_inicial),expression:"periodo_inicial"}]},[_vm._v("\n            no período de\n            "),_c('strong',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.periodo_inicial)))])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.periodo_final),expression:"periodo_final"}]},[_vm._v("\n            até "),_c('strong',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.periodo_final)))])])])])],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"in-out"}},[_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.showResults),expression:"showResults"}]},[_c('b-col',{attrs:{"cols":"12","sm":"3"}},[_c('div',{staticClass:"block",attrs:{"id":"filtrosResultados"}},[_c('b-form-group',{attrs:{"label":"Veículo de Publicação"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"filtroVeiculo","name":"flavour2","options":_vm.filtroVeiculo},model:{value:(_vm.filtroVeiculoSelected),callback:function ($$v) {_vm.filtroVeiculoSelected=$$v},expression:"filtroVeiculoSelected"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Tipo de Legislação"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"filtroTipoLegislacao","name":"flavour2","options":_vm.filtroTipoLegislacao},model:{value:(_vm.filtroTipoLegislacaoSelected),callback:function ($$v) {_vm.filtroTipoLegislacaoSelected=$$v},expression:"filtroTipoLegislacaoSelected"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Ano de Publicação"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"filtroAnoPublicacao","name":"flavour2","options":_vm.filtroAnoPublicacao},on:{"click":function($event){return _vm.onSubmitBusca()}},model:{value:(_vm.filtroAnoPublicacaoSelected),callback:function ($$v) {_vm.filtroAnoPublicacaoSelected=$$v},expression:"filtroAnoPublicacaoSelected"}})],1),_vm._v(" "),_c('b-link',{staticClass:"show-more d-inline",on:{"click":function($event){return _vm.showMore()}}},[_c('icon',{attrs:{"name":"caret-down"}}),_vm._v(" "),_c('span',[_vm._v(" ver mais ")])],1)],1)]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"9"}},[_vm._l((_vm.items),function(item,index){return _c('div',{key:index},[_c('buscaItem',{attrs:{"item":item}})],1)}),_vm._v(" "),_c('nav',{staticClass:"paginationNav"},[_c('b-pagination',{attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage,"prev-text":"Anterior","next-text":"Próximo","hide-goto-end-buttons":""},on:{"input":_vm.changePage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],2)],1)],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__("Tqaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__("qb6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_scss_estilos_scss__ = __webpack_require__("nd1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_scss_estilos_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_scss_estilos_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_icons_eye__ = __webpack_require__("5O9v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_awesome_icons_download__ = __webpack_require__("i71b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_awesome_icons_sign_in_alt__ = __webpack_require__("NK8H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_awesome_icons_caret_down__ = __webpack_require__("TFdi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_awesome_icons_spinner__ = __webpack_require__("epX/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_awesome_icons_times__ = __webpack_require__("1UlI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_awesome_icons_file_pdf__ = __webpack_require__("m7g/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL = "https://gazeta-pmc.aisolutions.tec.br/api";
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_0_axios___default.a);

// Client
var envAppClientData = "CUIABA";
var CLIENT = typeof envAppClientData === 'undefined' || envAppClientData === 'default' ? 'CUIABA' : envAppClientData;
var clientData = __webpack_require__("Z2pz")("./" + CLIENT + '/data.json');
var APP_ENVIROMENT = "homolog" === undefined ? 'prod' : "homolog";
var adminUrl = __webpack_require__.i({"NODE_ENV":"production"}).VUE_APP_ADMIN_URL === undefined ? '' : __webpack_require__.i({"NODE_ENV":"production"}).VUE_APP_ADMIN_URL;
/* harmony default export */ __webpack_exports__["default"] = ({ CLIENT: CLIENT, clientData: clientData, APP_ENVIROMENT: APP_ENVIROMENT, adminUrl: adminUrl

  // Configurando fonts para DOE-AL
});if (CLIENT === 'DOE-AL') {
  __webpack_require__("gGjJ");
}

// importando scss para o build


// vue awesome - font awesome
// import 'vue-awesome/icons' // importacao geral dos icones, compilacao pesa mais assim








__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('icon', __WEBPACK_IMPORTED_MODULE_17_vue_awesome_components_Icon__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_17_vue_awesome_components_Icon__["a" /* default */]
  }
});

/***/ }),

/***/ "NoUH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":"","id":"rodape"}},[_c('div',{attrs:{"id":"barraRodape"}}),_vm._v(" "),_c('b-container',{attrs:{"id":"conteudoRodape"}},[_c('b-row',[_c('b-col',{staticClass:"mb-4 mb-md-0 mb-lg-0 mb-xl-0",attrs:{"cols":"12","sm":"12","md":"6","lg":"6","xl":"6"}},[_c('h6',[_vm._v(_vm._s(_vm.tituloRodape))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.descricaoRodape)}})]),_vm._v(" "),_c('b-col',{staticClass:"mb-4 mb-md-0 mb-lg-0 mb-xl-0",class:_vm.logoRodapeClient,attrs:{"id":"logoRodape","cols":"12","sm":"12","md":"6","lg":"6","xl":"6"}},[_c('a',{staticClass:"text-sm-center text-center text-md-left text-lg-right text-xl-right d-block",attrs:{"href":_vm.logoRodapeLink,"target":"_blank"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.logoRodape,"title":_vm.logoRodapeTitulo,"alt":_vm.logoRodapeTitulo}})])])],1)],1),_vm._v(" "),_c('div',{attrs:{"id":"rodapeBGOver"}}),_vm._v(" "),_c('div',{attrs:{"id":"rodapeBGPattern"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OrFs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_locale_pt_br__ = __webpack_require__("AoDM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_locale_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_locale_pt_br__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_portal__ = __webpack_require__("ENzL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main_js__ = __webpack_require__("NHnr");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      client: null,
      perPage: 10,
      tituloPagina: 'Todas as legislações',
      decades: [],
      years: null,
      yearsMock: [],
      months: null,
      monthsMock: [],
      types: null,
      currentDecade: null,
      firstDecade: null,
      firstYear: null,
      firstMonth: null,
      currentYear: null,
      currentMonth: null,
      legislations: null,
      activeYear: null,
      activeYearName: null,
      activeMonthData: null,
      activeMonthName: null,
      activeTypeData: null,
      legislationsLoaded: false,
      legislationIsLoading: false,
      typeSelected: false,
      activeTypeName: null,
      totalDecades: null,
      fields: [{
        key: 'type',
        label: 'Título',
        sortable: false
      }, {
        key: 'publication_date',
        label: 'Data da publicação',
        sortable: false
      }, {
        key: 'epigrafe',
        label: 'Epígrafe',
        sortable: false,
        class: 'colEpigrafe'
      }, {
        key: 'acoes',
        label: 'Ações',
        class: 'text-center acoes'
      }],
      items: [],
      currentPage: 1,
      totalRows: 0
    };
  },
  created: function created() {
    var me = this;
    me.fetchDecades();
    me.client = __WEBPACK_IMPORTED_MODULE_6__main_js__["default"].CLIENT;
    me.tituloRowBG = {
      backgroundImage: 'url(' + __webpack_require__("9wcz")("./" + me.client + '/tituloPagFdo.png') + ')'
    };
  },

  methods: {
    fetchDecades: function fetchDecades() {
      if ("1962-07-16T04:00:00.000000Z" === undefined) {
        // console.error('LEGISLATIONS_FIRST_YEAR não configurado no ambiente, favor configurar no .env')
        return;
      }
      var me = this;
      var dataIni = __WEBPACK_IMPORTED_MODULE_3_moment___default()("1962-07-16T04:00:00.000000Z");
      var dataEnd = __WEBPACK_IMPORTED_MODULE_3_moment___default()();
      var firstYear = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.utc(dataIni).year();
      var currentYear = dataEnd.year();
      var firstDecade = me.getDecadesFromYear(firstYear);
      me.firstDecade = firstDecade;
      me.firstYear = firstYear;
      me.firstMonth = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.utc(dataIni).month() + 1;
      me.currentMonth = __WEBPACK_IMPORTED_MODULE_3_moment___default()().month() + 1;
      me.currentYear = currentYear;
      me.currentDecade = me.getDecadesFromYear(currentYear);
      me.totalDecades = parseInt((currentYear - firstDecade) / 10);
      me.createDecades();
    },
    getDecadesFromYear: function getDecadesFromYear(year) {
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default()(year) || year.toString().length < 4 || year.toString().length > 4) {
        throw new Error('Date must be valid and have a 4-digit year attribute');
      }
      var start = parseInt(Number(year) / 10) * 10;
      return start;
    },
    createDecades: function createDecades() {
      var me = this;
      for (var i = 0; i <= me.totalDecades; i++) {
        me.decades.push({
          id: i,
          decade: me.nameDecades(i),
          title: 'Anos ' + me.nameDecades(i)
        });
      }
    },
    nameDecades: function nameDecades(ind) {
      var me = this;
      return 2020 - (me.totalDecades - ind) * 10;
    },
    mockYears: function mockYears(item) {
      var me = this;

      var thisDecade = item.decade;

      var firstYear = item.decade;
      var endYear = item.decade + 9;

      if (thisDecade === me.firstDecade) {
        firstYear = me.firstYear;
      }

      if (thisDecade === me.currentDecade) {
        endYear = me.currentYear;
      }

      me.yearsMock = [];

      for (var i = firstYear; i <= endYear; i++) {
        me.yearsMock.push({
          id: i,
          title: i
        });
      }
    },
    loadYears: function loadYears(item) {
      var me = this;
      me.mockYears(item);
      me.years = me.yearsMock;
      me.activeYear = null;
      me.activeYearName = null;
      me.activeMonthName = null;
      me.months = null;
      me.types = null;
      me.legislations = null;
      me.legislationsLoaded = false;
      me.clearDecades();
      item.activeMenu = true;
    },
    nameMonths: function nameMonths(ind) {
      var monthName = '';
      var monthInd = ind.toString();
      switch (monthInd) {
        case '1':
          monthName = 'Janeiro';
          break;
        case '2':
          monthName = 'Fevereiro';
          break;
        case '3':
          monthName = 'Março';
          break;
        case '4':
          monthName = 'Abril';
          break;
        case '5':
          monthName = 'Maio';
          break;
        case '6':
          monthName = 'Junho';
          break;
        case '7':
          monthName = 'Julho';
          break;
        case '8':
          monthName = 'Agosto';
          break;
        case '9':
          monthName = 'Setembro';
          break;
        case '10':
          monthName = 'Outubro';
          break;
        case '11':
          monthName = 'Novembro';
          break;
        case '12':
          monthName = 'Dezembro';
          break;
        default:
          monthName = 'Erro';
      }
      return monthName;
    },
    mockMonths: function mockMonths(item) {
      var me = this;
      var thisYear = item.id;

      var startMonth = 1;
      var endMonth = 12;

      if (thisYear === me.firstYear) {
        startMonth = me.firstMonth;
      }

      if (thisYear === me.currentYear) {
        endMonth = me.currentMonth;
      }

      me.monthsMock = [];

      for (var i = startMonth; i <= endMonth; i++) {
        me.monthsMock.push({
          // id: '0' + i,
          id: i,
          title: me.nameMonths(i)
        });
      }
    },
    loadTypes: function loadTypes(item) {
      var me = this;
      var typesData = [];
      var typesInd = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(item);
      var start = 1;

      for (var i = 0; i < typesInd.length; i++) {
        typesData.push({
          id: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(item)[i],
          title: item[start]
        });
        start++;
      }

      me.types = typesData;
    },
    loadMonths: function loadMonths(item) {
      var me = this;
      me.legislations = null;
      me.types = null;
      me.legislationsLoaded = false;
      me.activeYear = item.id;
      me.activeYearName = item.title;
      me.activeMonthName = null;
      me.mockMonths(item);
      me.months = me.monthsMock;
      me.clearYears();
      item.activeMenu = true;
    },
    loadType: function loadType(item, typeChanged) {
      var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

      var me = this;
      me.legislationIsLoading = true;
      me.activeTypeData = item;
      me.clearTypes();
      item.activeMenu = true;
      me.activeTypeName = item.title;
      if (typeChanged) {
        me.currentPage = 1;
      }
      me.typeSelected = true;
      me.items = [];

      var activeMonth = me.activeMonthData.ind + 1;
      var activeType = item.id;
      var promisse = __WEBPACK_IMPORTED_MODULE_5__api_portal__["a" /* default */].fetchSelectedLegislationsByType(me.activeYear, activeMonth, activeType, page, me.perPage);
      promisse.then(function (items) {
        me.items = items.legislations.data;
        me.totalRows = items.legislations.total;
        me.legislationIsLoading = false;
        me.legislationsLoaded = true;
      });
    },
    clearDecades: function clearDecades() {
      var me = this;
      for (var i = 0; i < me.decades.length; i++) {
        if (me.decades[i].activeMenu === true) me.decades[i].activeMenu = false;
      }
    },
    clearYears: function clearYears() {
      var me = this;
      for (var i = 0; i < me.years.length; i++) {
        if (me.years[i].activeMenu === true) me.years[i].activeMenu = false;
      }
    },
    clearMonths: function clearMonths() {
      var me = this;
      for (var i = 0; i < me.months.length; i++) {
        if (me.months[i].activeMenu === true) me.months[i].activeMenu = false;
      }
    },
    clearTypes: function clearTypes() {
      var me = this;
      for (var i = 0; i < me.types.length; i++) {
        if (me.types[i].activeMenu === true) me.types[i].activeMenu = false;
      }
    },
    resetTypes: function resetTypes() {
      var me = this;
      var monthData = me.activeMonthData;
      if (monthData) {
        me.types = null;
        me.currentPage = 1;
        me.loadLegislations(monthData.item, monthData.ind);
      }
    },
    loadLegislations: function loadLegislations(item, ind) {
      var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

      var me = this;
      me.legislationIsLoading = true;
      me.activeMonthData = {
        item: item,
        ind: ind
      };
      me.activeMonthName = item.title;
      me.clearMonths();
      item.activeMenu = true;
      me.items = null;
      me.typeSelected = false;

      var activeMonth = parseInt(ind) + 1;
      var promisse = __WEBPACK_IMPORTED_MODULE_5__api_portal__["a" /* default */].fetchSelectedLegislations(me.activeYear, activeMonth, page, me.perPage);
      promisse.then(function (items) {
        me.items = items.legislations.data;
        me.totalRows = items.legislations.total;
        me.legislationIsLoading = false;
        me.legislationsLoaded = true;
        if (items.legislations.data.length) {
          me.loadTypes(items.types, false);
        }
      });
    },
    changePage: function changePage() {
      var me = this;
      var monthData = me.activeMonthData;
      if (monthData) {
        if (me.typeSelected) {
          me.loadType(me.activeTypeData, false, me.currentPage);
        } else {
          me.loadLegislations(monthData.item, monthData.ind, me.currentPage);
        }
      }
    },
    viewLegislation: function viewLegislation(legislationId) {
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      if (page == null) {
        page = 1;
      }
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.baseURL + '/editions/viewPdf/' + legislationId + '#page=' + page;
    },
    downloadLegislation: function downloadLegislation(legislationId) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.baseURL + '/editions/downloadPdf/' + legislationId;
    }
  },
  filters: {
    formatDate: function formatDate(value) {
      if (value) {
        return __WEBPACK_IMPORTED_MODULE_3_moment___default.a.utc(String(value)).format('LL');
      }
      return '-';
    },
    formatEpigrafe: function formatEpigrafe(value) {
      if (value) {
        return value;
      }
      return '-';
    },
    formatViews: function formatViews(value) {
      if (!value) {
        return '0';
      }
    }
  }
});

/***/ }),

/***/ "PpCb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"tituloPaginaRow",style:(_vm.tituloRowBG)},[_c('h1',{staticClass:"tituloPagina"},[_vm._v("\n      "+_vm._s(_vm.tituloPagina)+"\n    ")])]),_vm._v(" "),_c('b-row',{staticClass:"p-3 p-sm-0 p-md-0 p-lg-0 p-xl-0"},[_c('b-form',{staticClass:"mb-0",attrs:{"id":"formBusca"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search()},"reset":_vm.onResetSearch}},[(_vm.client === 'DOE-AL')?_c('p',[_vm._v("\n        Realize sua busca, utilizando o critério desejado. Para isso, preencha\n        qualquer um dos campos abaixo.\n      ")]):_c('p',[_vm._v("\n        Busque as edições publicadas com o critério desejado preenchendo os\n        campos abaixo.\n      ")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"d-sm-inline-block d-md-none px-4 text-center",attrs:{"cols":"12"}},[_c('img',{staticClass:"w-75",attrs:{"src":__webpack_require__("Co5Y"),"alt":"Imagem de busca nas edições"}})]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","md":"10"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"id":"inputGrupoPalavraChave"}},[_c('b-form-input',{attrs:{"id":"inputPalavraChave","type":"text","placeholder":"Buscar por: (Qualquer palavra...)"},model:{value:(_vm.formBusca.keywords),callback:function ($$v) {_vm.$set(_vm.formBusca, "keywords", $$v)},expression:"formBusca.keywords"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('b-form-group',{attrs:{"id":"inputGrupoPeriodoInicial","label":"Período inicial:","label-for":"inputPeriodoInicial"}},[_c('b-form-input',{attrs:{"id":"inputPeriodoInicial","type":"date","placeholder":"Período inicial ..."},model:{value:(_vm.periodo_inicial),callback:function ($$v) {_vm.periodo_inicial=$$v},expression:"periodo_inicial"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('b-form-group',{attrs:{"id":"inputGrupoPeriodoFinal","label":"Período final:","label-for":"inputPeriodoFinal"}},[_c('b-form-input',{attrs:{"id":"inputPeriodoFinal","type":"date","placeholder":"Período final ..."},model:{value:(_vm.periodo_final),callback:function ($$v) {_vm.periodo_final=$$v},expression:"periodo_final"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('b-form-group',{attrs:{"id":"inputGrupoNumeroEdicao","label":"Número da Edição:","label-for":"inputNumeroEdicao"}},[_c('b-form-input',{attrs:{"id":"inputNumeroEdicao","type":"text","placeholder":"Edição Nº..."},model:{value:(_vm.formBusca.edition_number),callback:function ($$v) {_vm.$set(_vm.formBusca, "edition_number", $$v)},expression:"formBusca.edition_number"}})],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"d-none d-md-inline-block pt-2",attrs:{"cols":"12","sm":"2","md":"2","lg":"2","xl":"2"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("Co5Y"),"alt":"Imagem de busca nas edições"}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"5"}},[_c('b-form-group',{attrs:{"id":"selectGrupoBuscaTipo","label":"Buscar por:","label-for":"selectBuscaTipo"}},[_c('v-select',{attrs:{"id":"selectBuscaTipo","placeholder":"Selecione o tipo da busca","label":"title","options":_vm.searchTypeOptions},model:{value:(_vm.formBusca.searchType),callback:function ($$v) {_vm.$set(_vm.formBusca, "searchType", $$v)},expression:"formBusca.searchType"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"5"}},[_c('b-form-group',{attrs:{"id":"selectGrupoOrdenacao","label":"Ordenar por:","label-for":"selectOrdenacao"}},[_c('v-select',{attrs:{"id":"selectOrdenacao","placeholder":"Selecione a ordenação da busca","label":"title","options":_vm.orderOptions},model:{value:(_vm.formBusca.order),callback:function ($$v) {_vm.$set(_vm.formBusca, "order", $$v)},expression:"formBusca.order"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"pt-4 pl-0",attrs:{"cols":"12","sm":"10"}},[_c('b-form-group',{staticClass:"float-right"},[_c('b-button',{staticClass:"mt-2 mr-1",attrs:{"type":"reset","variant":"cinzaClaro"}},[_vm._v("\n                  Limpar\n                ")]),_vm._v(" "),_c('b-button',{staticClass:"mt-2",attrs:{"type":"button","variant":"primary"},on:{"click":function($event){return _vm.search()}}},[_vm._v("\n                  Buscar\n                ")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"pt-4 pl-0 d-none d-sm-inline-block",attrs:{"cols":"2"}})],1)],1)],1)],1)],1),_vm._v(" "),[_c('transition',{attrs:{"name":"fade","mode":"in-out"}},[_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearching),expression:"showSearching"}],staticClass:"mt-4",staticStyle:{"height":"100vh"}},[_c('b-col',{attrs:{"cols":"12"}},[_c('h1',{staticClass:"tituloPagina"},[_vm._v("\n            Buscando por\n            "),_c('span',{staticClass:"palavraResultado"},[_vm._v(_vm._s(_vm.resultKeywords))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.periodo_inicial),expression:"periodo_inicial"}]},[_vm._v("\n              no período de\n              "),_c('strong',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.periodo_inicial)))])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.periodo_final),expression:"periodo_final"}]},[_vm._v("\n              até "),_c('strong',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.periodo_final)))])]),_vm._v("\n            ...\n          ")])])],1)],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"in-out"}},[_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.showResults),expression:"showResults"}],staticClass:"mt-4 tituloPaginaRow",style:(_vm.tituloRowBG),attrs:{"id":"areaResultados"}},[_c('h1',{staticClass:"tituloPagina"},[_vm._v("\n          "+_vm._s(_vm.tituloResultado)+"\n        ")])])],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"in-out"}},[_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.showResults),expression:"showResults"}],staticClass:"p-3 p-sm-0 p-md-0 p-lg-0 p-xl-0"},[_c('p',[_vm._v("\n          Exibindo "),_c('strong',[_vm._v(_vm._s(_vm.totalRows))]),_vm._v(" resultados para a consulta\n          "),_c('span',{staticClass:"palavraResultado"},[_vm._v(_vm._s(_vm.resultKeywords))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.periodo_inicial),expression:"periodo_inicial"}]},[_vm._v("\n            no período de\n            "),_c('strong',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.periodo_inicial)))])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.periodo_final),expression:"periodo_final"}]},[_vm._v("\n            até "),_c('strong',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.periodo_final)))])])])])],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"in-out"}},[_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.showResults),expression:"showResults"}]},[_c('b-col',{attrs:{"cols":"12","sm":"3"}},[_c('div',{staticClass:"block",attrs:{"id":"filtrosResultados"}},[_c('b-form-group',{attrs:{"label":"Veículo de Publicação"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"filtroVeiculo","name":"flavour2","options":_vm.filtroVeiculo},on:{"change":function($event){return _vm.changeFilters()}},model:{value:(_vm.filtroVeiculoSelected),callback:function ($$v) {_vm.filtroVeiculoSelected=$$v},expression:"filtroVeiculoSelected"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Tipo de Edição"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"filtroTipoEdicao","name":"flavour2","options":_vm.filtroTipoEdicao},on:{"change":function($event){return _vm.changeFilters()}},model:{value:(_vm.filtroTipoEdicaoSelected),callback:function ($$v) {_vm.filtroTipoEdicaoSelected=$$v},expression:"filtroTipoEdicaoSelected"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Ano de Publicação"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"filtroAnoPublicacao","name":"flavour2","options":_vm.filtroAnoPublicacao},on:{"change":function($event){return _vm.changeFilters()}},model:{value:(_vm.filtroAnoPublicacaoSelected),callback:function ($$v) {_vm.filtroAnoPublicacaoSelected=$$v},expression:"filtroAnoPublicacaoSelected"}})],1),_vm._v(" "),_c('b-row',{staticClass:"text-center"},[_c('b-col',{attrs:{"cols":"12"}},[_c('b-button',{attrs:{"type":"button","variant":"primary","disabled":_vm.disableClearFilters},on:{"click":function($event){return _vm.clearFilters()}}},[_vm._v("\n                  Redefinir filtros\n                ")])],1)],1)],1)]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"9"}},[_vm._l((_vm.items),function(item,index){return _c('div',{key:index},[_c('buscaItem',{attrs:{"item":item,"result":_vm.resultKeywords}})],1)}),_vm._v(" "),_c('nav',{staticClass:"paginationNav"},[_c('b-pagination',{attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage,"prev-text":"Anterior","next-text":"Próximo","hide-goto-end-buttons":""},on:{"input":_vm.changePage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],2)],1)],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q9cC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pdftron_pdfjs_express_viewer__ = __webpack_require__("tweR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pdftron_pdfjs_express_viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pdftron_pdfjs_express_viewer__);
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'WebViewer',
  props: {
    path: String
  },
  data: function data() {
    return {
      pathUrl: '',
      searchTerm: '',
      pageNum: 1
    };
  },
  mounted: function mounted() {
    var me = this;
    me.pathUrl = window.localStorage.getItem('pathUrl');
    me.searchTerm = window.localStorage.getItem('searchTerm');
    me.pageNum = parseInt(window.localStorage.getItem('pageNum'));
    __WEBPACK_IMPORTED_MODULE_0__pdftron_pdfjs_express_viewer___default()({
      path: '/dist/static/pdfjsexpress',
      initialDoc: me.pathUrl,
      licenseKey: "gibsC6mFBzOSQubHngL0"
    }, this.$refs.viewer).then(function (instance) {
      // now you can access APIs through the WebViewer instance
      var Core = instance.Core,
          UI = instance.UI;
      // const { documentViewer, Core, annotationManager, Annotations } =

      var _instance$Core = instance.Core,
          documentViewer = _instance$Core.documentViewer,
          annotationManager = _instance$Core.annotationManager,
          Annotations = _instance$Core.Annotations;

      // Core.documentViewer.addEventListener('documentLoaded', () => {

      documentViewer.addEventListener('documentLoaded', function () {
        var searchValue = me.searchTerm;

        // set the ui language to pt_BR
        instance.UI.setLanguage('pt_br');

        // instance.UI.searchText(searchValue) // search on page
        instance.UI.searchTextFull(searchValue);
      });

      Core.documentViewer.addEventListener('activeSearchResultChanged', function () {
        Core.documentViewer.setCurrentPage(me.pageNum);
      });

      // adding an event listener for when the page number has changed
      Core.documentViewer.addEventListener('pageNumberUpdated', function (pageNumber) {
        //
      });

      // adds a button to the header that on click sets the page to the next page
      UI.setHeaderItems(function (header) {
        header.push({
          type: 'actionButton',
          img: 'https://icons.getbootstrap.com/assets/icons/caret-right-fill.svg',
          onClick: function onClick() {
            var currentPage = Core.documentViewer.getCurrentPage();
            var totalPages = Core.documentViewer.getPageCount();
            var atLastPage = currentPage === totalPages;

            if (atLastPage) {
              Core.documentViewer.setCurrentPage(1);
            } else {
              Core.documentViewer.setCurrentPage(currentPage + 1);
            }
          }
        });
      });
    });
  }
});

/***/ }),

/***/ "RzGs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edicoes_vue__ = __webpack_require__("WfIT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf4fb1f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edicoes_vue__ = __webpack_require__("jzIP");
function injectStyle (ssrContext) {
  __webpack_require__("8EO7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edicoes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf4fb1f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edicoes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TRr2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"id":"menuSite"}},[_c('b-row',{attrs:{"id":"containerMenu"}},[_c('router-link',{staticClass:"d-none d-md-block",attrs:{"id":"logoSite","to":"/","exact":""}},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.logoTopo}})]),_vm._v(" "),(_vm.client === 'CUIABA')?_c('div',{attrs:{"id":"tituloSite"}},[_c('h1',[_vm._v("\n        "+_vm._s(_vm.tituloTopo)+"\n      ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("\n        "+_vm._s(_vm.descricaoTopo)+"\n      ")])]):_vm._e(),_vm._v(" "),(_vm.client === 'DOE-AL')?_c('div',{attrs:{"id":"imagemTopo"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.imagemTopo}})]):_vm._e(),_vm._v(" "),(_vm.client !== 'DOE-AL')?_c('div',[_c('div',{staticClass:"d-none d-md-block",attrs:{"id":"fundoMenu"}},[_c('ul',{staticClass:"nav pl-lg-4 w-100"},[_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/","exact":""}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/busca"}},[_vm._v("Busca")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/edicoes"}},[_vm._v("Edições")])],1),_vm._v(" "),(_vm.client === 'CUIABA')?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/legislacoes"}},[_vm._v("\n              Legislações\n            ")])],1):_vm._e(),_vm._v(" "),(_vm.client === 'CUIABA')?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/sobre"}},[_vm._v("Sobre")])],1):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.client === 'DOE-AL')?_c('div',{staticClass:"d-none d-md-block",attrs:{"id":"fundoMenu"}},[_c('ul',{staticClass:"nav pl-lg-4 w-100"},[_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/","exact":""}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/busca"}},[_vm._v("Busca")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/edicoes"}},[_vm._v("Edições")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/publicar-no-diario"}},[_vm._v("Publicar no Diário Oficial")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/sobre"}},[_vm._v("Sobre")])],1)])]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"d-block d-sm-block d-md-none py-1 my-1",attrs:{"id":"logoSiteMobile","to":"/","exact":""}},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.logoTopo}})]),_vm._v(" "),_c('div',{staticClass:"d-block d-sm-block d-md-none",attrs:{"id":"fundoMenuMobile"}},[_c('b-navbar',{attrs:{"toggleable":"md","type":"dark"}},[_c('b-navbar-toggle',{attrs:{"target":"nav_collapse"}}),_vm._v(" "),(_vm.client !== 'CUIABA')?_c('b-navbar-brand',{attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.titleMobile))]):_vm._e(),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"nav_collapse"}},[_c('ul',{staticClass:"nav nav-pills nav-fill"},[_c('li',{staticClass:"nav-item",attrs:{"variant":"cinzaClaro"}},[_c('router-link',{staticClass:"nav-link",attrs:{"variant":"cinzaClaro","to":"/","exact":""}},[_vm._v("\n                Home\n              ")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/busca"}},[_vm._v(" Busca ")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/edicoes"}},[_vm._v("\n                Edições\n              ")])],1),_vm._v(" "),(_vm.client === 'CUIABA')?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/legislacoes"}},[_vm._v("\n                Legislações\n              ")])],1):_vm._e(),_vm._v(" "),(_vm.client === 'DOE-AL')?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/publicar-no-diario"}},[_vm._v("\n                Publicar no Diário Oficial\n              ")])],1):_vm._e(),_vm._v(" "),(_vm.client === 'CUIABA' || _vm.client === 'DOE-AL')?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/sobre"}},[_vm._v(" Sobre ")])],1):_vm._e()])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VMis":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"viewer"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VMjJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_locale_pt_br__ = __webpack_require__("AoDM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_locale_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_locale_pt_br__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BuscaItem',
  props: {
    item: Object,
    result: String
  },
  data: function data() {
    return {};
  },

  methods: {
    downloadEdition: function downloadEdition(editionId) {
      return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL + '/editions/downloadPdf/' + editionId;
    },
    downloadPage: function downloadPage(editionId, pageNumber) {
      return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL + '/editions/viewPdf/' + editionId + '#page=' + pageNumber + '&search="' + this.result + '"';
    },
    preparePDF: function preparePDF(editionID, pageNum) {
      var searchTerm = this.result;
      var pathUrl = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL + '/editions/viewPdf/' + editionID;

      window.localStorage.setItem('pathUrl', pathUrl);
      window.localStorage.setItem('searchTerm', searchTerm);
      window.localStorage.setItem('pageNum', pageNum.toString());

      window.open('../../#/ver-edicao?file=' + encodeURIComponent(pathUrl) + '&page=' + pageNum + '&searchTerm=' + searchTerm, '_blank');
    }
  },
  computed: {
    pdfJsExpressKey: function pdfJsExpressKey() {
      return "gibsC6mFBzOSQubHngL0";
    }
  },
  filters: {
    formatDate: function formatDate(value) {
      if (value) {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(String(value)).format('LL');
      }

      return '-';
    },
    formatHL: function formatHL(value) {
      var ret = value[0].replace('<em>', '<strong>').replace('<\\/em>', '</strong>');
      return ret;
    }
  }
});

/***/ }),

/***/ "WfIT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_locale_pt_br__ = __webpack_require__("AoDM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_locale_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_locale_pt_br__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_portal__ = __webpack_require__("ENzL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main_js__ = __webpack_require__("NHnr");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      client: null,
      perPage: 5,
      tituloPagina: 'Todas as edições',
      decades: [],
      years: null,
      yearsMock: [],
      months: null,
      monthsMock: [],
      currentDecade: null,
      firstDecade: null,
      firstYear: null,
      firstMonth: null,
      currentYear: null,
      currentMonth: null,
      editions: null,
      activeYear: null,
      activeYearName: null,
      activeMonthName: null,
      editionsLoaded: false,
      editionIsLoading: false,
      totalDecades: null,
      fields: [{
        key: 'number',
        label: 'Edição',
        sortable: false
      }, {
        key: 'publication_date',
        label: 'Data da publicação',
        sortable: false
      }, {
        key: 'downloads',
        label: 'Visualizações',
        sortable: false
      }, {
        key: 'acoes',
        label: 'Ações',
        class: 'text-center'
      }],
      items: []
    };
  },
  created: function created() {
    var me = this;
    me.fetchDecades();
    me.client = __WEBPACK_IMPORTED_MODULE_5__main_js__["default"].CLIENT;
    me.tituloRowBG = {
      backgroundImage: 'url(' + __webpack_require__("9wcz")("./" + me.client + '/tituloPagFdo.png') + ')'
    };
  },

  methods: {
    fetchDecades: function fetchDecades() {
      if ("1967-01-02T04:00:00.000000Z" === undefined) {
        // console.error('EDITIONS_FIRST_YEAR não configurado no ambiente, favor configurar no .env')
        return;
      }
      var me = this;
      var dataIni = __WEBPACK_IMPORTED_MODULE_2_moment___default()("1967-01-02T04:00:00.000000Z");
      var dataEnd = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
      var firstYear = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(dataIni).year();
      var currentYear = dataEnd.year();
      var firstDecade = me.getDecadesFromYear(firstYear);
      me.firstDecade = firstDecade;
      me.firstYear = firstYear;
      me.firstMonth = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(dataIni).month() + 1;
      me.currentMonth = __WEBPACK_IMPORTED_MODULE_2_moment___default()().month() + 1;
      me.currentYear = currentYear;
      me.currentDecade = me.getDecadesFromYear(currentYear);
      me.totalDecades = parseInt((currentYear - firstDecade) / 10);
      me.createDecades();
    },
    getDecadesFromYear: function getDecadesFromYear(year) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(year) || year.toString().length < 4 || year.toString().length > 4) {
        throw new Error('Date must be valid and have a 4-digit year attribute');
      }
      var start = parseInt(Number(year) / 10) * 10;
      return start;
    },
    createDecades: function createDecades() {
      var me = this;
      for (var i = 0; i <= me.totalDecades; i++) {
        me.decades.push({
          id: i,
          decade: me.nameDecades(i),
          title: 'Anos ' + me.nameDecades(i)
        });
      }
    },
    nameDecades: function nameDecades(ind) {
      var me = this;
      return 2020 - (me.totalDecades - ind) * 10;
    },
    mockYears: function mockYears(item) {
      var me = this;

      var thisDecade = item.decade;

      var firstYear = item.decade;
      var endYear = item.decade + 9;

      if (thisDecade === me.firstDecade) {
        firstYear = me.firstYear;
      }

      if (thisDecade === me.currentDecade) {
        endYear = me.currentYear;
      }

      me.yearsMock = [];

      for (var i = firstYear; i <= endYear; i++) {
        me.yearsMock.push({
          id: i,
          title: i
        });
      }
    },
    loadYears: function loadYears(item) {
      var me = this;
      me.mockYears(item);
      me.years = me.yearsMock;
      me.activeYear = null;
      me.activeYearName = null;
      me.activeMonthName = null;
      me.months = null;
      me.editions = null;
      me.editionsLoaded = false;
      me.clearDecades();
      item.activeMenu = true;
    },
    nameMonths: function nameMonths(ind) {
      var monthName = '';
      var monthInd = ind.toString();
      switch (monthInd) {
        case '1':
          monthName = 'Janeiro';
          break;
        case '2':
          monthName = 'Fevereiro';
          break;
        case '3':
          monthName = 'Março';
          break;
        case '4':
          monthName = 'Abril';
          break;
        case '5':
          monthName = 'Maio';
          break;
        case '6':
          monthName = 'Junho';
          break;
        case '7':
          monthName = 'Julho';
          break;
        case '8':
          monthName = 'Agosto';
          break;
        case '9':
          monthName = 'Setembro';
          break;
        case '10':
          monthName = 'Outubro';
          break;
        case '11':
          monthName = 'Novembro';
          break;
        case '12':
          monthName = 'Dezembro';
          break;
        default:
          monthName = 'Erro';
      }
      return monthName;
    },
    mockMonths: function mockMonths(item) {
      var me = this;
      var thisYear = item.id;

      var startMonth = 1;
      var endMonth = 12;

      if (thisYear === me.firstYear) {
        startMonth = me.firstMonth;
      }

      if (thisYear === me.currentYear) {
        endMonth = me.currentMonth;
      }

      me.monthsMock = [];

      for (var i = startMonth; i <= endMonth; i++) {
        me.monthsMock.push({
          id: '0' + i,
          title: me.nameMonths(i)
        });
      }
    },
    loadMonths: function loadMonths(item) {
      var me = this;
      me.editions = null;
      me.editionsLoaded = false;
      me.activeYear = item.id;
      me.activeYearName = item.title;
      me.activeMonthName = null;
      me.mockMonths(item);
      me.months = me.monthsMock;
      me.clearYears();
      item.activeMenu = true;
    },
    clearDecades: function clearDecades() {
      var me = this;
      for (var i = 0; i < me.decades.length; i++) {
        if (me.decades[i].activeMenu === true) me.decades[i].activeMenu = false;
      }
    },
    clearYears: function clearYears() {
      var me = this;
      for (var i = 0; i < me.years.length; i++) {
        if (me.years[i].activeMenu === true) me.years[i].activeMenu = false;
      }
    },
    clearMonths: function clearMonths() {
      var me = this;
      for (var i = 0; i < me.months.length; i++) {
        if (me.months[i].activeMenu === true) me.months[i].activeMenu = false;
      }
    },
    loadEditions: function loadEditions(item, ind) {
      var me = this;
      me.editionIsLoading = true;
      me.activeMonthName = item.title;
      me.clearMonths();
      item.activeMenu = true;
      me.items = [];
      var activeMonth = parseInt(ind) + 1;
      var promisse = __WEBPACK_IMPORTED_MODULE_4__api_portal__["a" /* default */].fetchSelectedEditions(me.activeYear, activeMonth);
      promisse.then(function (items) {
        me.items = items.editions;
        me.perPage = me.items.length;
        me.editionIsLoading = false;
        me.editionsLoaded = true;
      });
    },
    viewEdition: function viewEdition(editionId) {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL + '/editions/viewPdf/' + editionId;
    },
    downloadEdition: function downloadEdition(editionId) {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL + '/editions/downloadPdf/' + editionId;
    }
  },
  filters: {
    formatDate: function formatDate(value) {
      if (value) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(String(value)).format('LL');
      }
      return '-';
    },
    formatSuplement: function formatSuplement(value) {
      if (value === 1 || value === '1') {
        return ' - Suplemento';
      }
      return '';
    }
  }
});

/***/ }),

/***/ "XDpy":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "YKlk":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./CUIABA/diariobg.jpg": "1yyV",
	"./PMVG/diariobg.jpg": "HqUf",
	"./TCE-AL/diariobg.jpg": "Jh4b"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YKlk";

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Sobre__ = __webpack_require__("w0xu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Busca__ = __webpack_require__("l2uB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Edicoes__ = __webpack_require__("RzGs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_BuscaLegislacoes__ = __webpack_require__("GxUR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Legislacoes__ = __webpack_require__("DYLJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PublicarDiarioOficial__ = __webpack_require__("C73V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_VerEdicao__ = __webpack_require__("qp3q");











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  linkActiveClass: 'active',
  mode: 'hash',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, {
    path: '/portal',
    name: 'HomePortal',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, {
    path: '/edicoes',
    name: 'Edições',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Edicoes__["a" /* default */]
  }, {
    path: '/legislacoes',
    name: 'Legislações',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Legislacoes__["a" /* default */]
  }, {
    path: '/sobre',
    name: 'Sobre',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Sobre__["a" /* default */]
  }, {
    path: '/busca',
    name: 'Busca',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Busca__["a" /* default */]
  }, {
    path: '/busca-legislacoes',
    name: 'Busca de Legislações',
    component: __WEBPACK_IMPORTED_MODULE_6__components_BuscaLegislacoes__["a" /* default */]
  }, {
    path: '/publicar-no-diario',
    name: 'Publicar no Diário Oficial',
    component: __WEBPACK_IMPORTED_MODULE_8__components_PublicarDiarioOficial__["a" /* default */]
  }, {
    path: '/ver-edicao',
    name: 'Ver Edição',
    component: __WEBPACK_IMPORTED_MODULE_9__components_VerEdicao__["a" /* default */]
  }]
}));

/***/ }),

/***/ "Z+Yt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gazetaTopo1.99859ec.png";

/***/ }),

/***/ "Z2pz":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./CUIABA/data.json": "kmPt",
	"./DOE-AL/data.json": "qJ/2",
	"./PMVG/data.json": "D7CY",
	"./TCE-AL/data.json": "gX4K"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Z2pz";

/***/ }),

/***/ "aAHW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aSWz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_js__ = __webpack_require__("NHnr");
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      client: null,
      tituloPagina: '',
      tituloRowBG: '',
      textoSobre: '',
      tituloContato: ''
    };
  },
  created: function created() {
    var me = this;
    me.client = __WEBPACK_IMPORTED_MODULE_0__main_js__["default"].CLIENT;
    me.tituloPagina = __WEBPACK_IMPORTED_MODULE_0__main_js__["default"].clientData.about.title;
    me.textoSobre = __WEBPACK_IMPORTED_MODULE_0__main_js__["default"].clientData.about.text;
    me.tituloContato = __WEBPACK_IMPORTED_MODULE_0__main_js__["default"].clientData.about.contactText;
    me.tituloRowBG = {
      backgroundImage: 'url(' + __webpack_require__("9wcz")("./" + me.client + '/tituloPagFdo.png') + ')'
    };
  },

  computed: {
    justifiedText: function justifiedText() {
      return this.client === 'DOE-AL' ? 'text-justify' : '';
    }
  }
});

/***/ }),

/***/ "bHm5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.6432b87.png";

/***/ }),

/***/ "boC1":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./CUIABA/logo.png": "f8V1",
	"./DOE-AL/logo.png": "zRJ2",
	"./PMVG/logo.png": "tbNJ",
	"./TCE-AL/logo.png": "bHm5"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "boC1";

/***/ }),

/***/ "c/Cr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-item block"},[_c('b-row',{staticClass:"mx-auto"},[_c('h6',[_vm._v("\n      "+_vm._s(_vm.item.legislation_type_name)+" №\n      "+_vm._s(_vm.item.legislation_number)+" - Página "+_vm._s(_vm.item.page_number)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"item-actions"},[_c('b-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"d-inline",attrs:{"target":"_blank","href":_vm.downloadPage(_vm.item.legislation_id, _vm.item.page_number),"title":"Baixar página encontrada"}},[_c('icon',{attrs:{"name":"download"}}),_vm._v(" "),_c('span',[_vm._v(" Página Encontrada ")])],1),_vm._v("\n       \n      "),_c('b-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"d-inline",attrs:{"href":_vm.downloadLegislation(_vm.item.legislation_id),"title":"Baixar legislação"}},[_c('icon',{attrs:{"name":"download"}}),_vm._v(" "),_c('span',[_vm._v(" Legislação Completa ")])],1)],1)]),_vm._v(" "),_c('b-row',{staticClass:"mx-auto mb-2"},[_c('span',{staticClass:"item-data"},[_vm._v(" "+_vm._s(_vm._f("formatDate")(_vm.item.publication_date)))])]),_vm._v(" "),_c('b-row',{staticClass:"mx-auto"},[_c('p',{staticClass:"item-result",domProps:{"innerHTML":_vm._s(
        _vm.item.highlight[0]
          .replace(/<em>/g, '<strong>')
          .replace(/<\\\/em>/g, '</strong>')
      )}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cc0X":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gazetaTopo1.c29f997.png";

/***/ }),

/***/ "d9C8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dXrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);



var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fa-icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
          return false;
        }
        return true;
      }
    },
    title: String,
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String,
    tabindex: [Number, String]
  },
  data: function data() {
    return {
      id: getId(),
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      }, this.$options.name, true);
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    },
    focusable: function focusable() {
      var tabindex = this.tabindex;

      if (tabindex == null) {
        return 'false';
      }
      var index = typeof tabindex === 'string' ? parseInt(tabindex, 10) : tabindex;
      if (index >= 0) {
        return null;
      }
      return 'false';
    }
  },
  mounted: function mounted() {
    this.updateStack();
  },
  updated: function updated() {
    this.updateStack();
  },

  methods: {
    updateStack: function updateStack() {
      var _this = this;

      if (!this.name && this.name !== null && this.$children.length === 0) {
        console.warn('Invalid prop: prop "name" is required.');
        return;
      }

      if (this.icon) {
        return;
      }

      var width = 0;
      var height = 0;
      this.$children.forEach(function (child) {
        child.outerScale = _this.normalizedScale;

        width = Math.max(width, child.width);
        height = Math.max(height, child.height);
      });
      this.childrenWidth = width;
      this.childrenHeight = height;
      this.$children.forEach(function (child) {
        child.x = (width - child.width) / 2;
        child.y = (height - child.height) / 2;
      });
    }
  },
  render: function render(h) {
    if (this.name === null) {
      return h();
    }

    var options = {
      class: this.klass,
      style: this.style,
      attrs: {
        role: this.$attrs.role || (this.label || this.title ? 'img' : null),
        'aria-label': this.label || null,
        'aria-hidden': String(!(this.label || this.title)),
        tabindex: this.tabindex,
        x: this.x,
        y: this.y,
        width: this.width,
        height: this.height,
        viewBox: this.box,
        focusable: this.focusable
      }
    };

    var titleId = 'vat-' + this.id;
    if (this.title) {
      options.attrs['aria-labelledby'] = titleId;
    }

    if (this.raw) {
      var html = this.raw;

      if (this.title) {
        html = '<title id="' + titleId + '">' + escapeHTML(this.title) + '</title>' + html;
      }

      options.domProps = {
        innerHTML: html
      };
    }

    var content = this.title ? [h('title', { attrs: { id: titleId } }, this.title)] : [];

    return h('svg', options, this.raw ? null : content.concat(this.$slots.default || [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.icon.paths.map(function (path, i) {
      return h('path', {
        attrs: path,
        key: 'path-' + i
      });
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.icon.polygons.map(function (polygon, i) {
      return h('polygon', {
        attrs: polygon,
        key: 'polygon-' + i
      });
    })))));
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];
      var _icon$paths = icon.paths,
          paths = _icon$paths === undefined ? [] : _icon$paths,
          d = icon.d,
          _icon$polygons = icon.polygons,
          polygons = _icon$polygons === undefined ? [] : _icon$polygons,
          points = icon.points;


      if (d) {
        paths.push({ d: d });
      }

      if (points) {
        polygons.push({ points: points });
      }

      icons[name] = assign({}, icon, {
        paths: paths,
        polygons: polygons
      });
    }
  },

  icons: icons
});

function assign(obj) {
  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  sources.forEach(function (source) {
    for (var key in source) {
      if (source.hasOwnProperty(key)) {
        obj[key] = source[key];
      }
    }
  });

  return obj;
}

var cursor = 0xd4937;
function getId() {
  return 'va-' + (cursor++).toString(16);
}

var ESCAPE_MAP = {
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  '&': '&amp;'
};

function escapeHTML(html) {
  return html.replace(/[<>"&]/g, function (c) {
    return ESCAPE_MAP[c] || c;
  });
}

/***/ }),

/***/ "f8V1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.25fbf75.png";

/***/ }),

/***/ "fy8N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_js__ = __webpack_require__("NHnr");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Menu',
  data: function data() {
    return {
      client: null,
      logoTopo: '',
      imagemTopo: '',
      titleMobile: '',
      tituloTopo: 'GAZETA MUNICIPAL',
      descricaoTopo: 'Prefeitura Municipal de Cuiab\xE1 - MT',
      formLogin: {
        usuario: '',
        senha: ''
      }
    };
  },
  created: function created() {
    var me = this;
    me.client = __WEBPACK_IMPORTED_MODULE_1__main_js__["default"].CLIENT;
    me.titleMobile = __WEBPACK_IMPORTED_MODULE_1__main_js__["default"].clientData.titleMobile;
    me.logoTopo = __webpack_require__("boC1")("./" + me.client + '/logo.png');
    if (me.client === 'DOE-AL') {
      me.imagemTopo = __webpack_require__("JYW+")("./" + me.client + '/logo_diario.png');
    }
  },

  methods: {
    onSubmit: function onSubmit(evt) {
      evt.preventDefault();
      alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formLogin));
    }
  }
});

/***/ }),

/***/ "g8fZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rodapeLogo.5beadd4.png";

/***/ }),

/***/ "gGjJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gPVK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_js__ = __webpack_require__("NHnr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      client: null,
      tituloRodape: 'Prefeitura Municipal de Cuiabá',
      descricaoRodape: '',
      logoRodape: '',
      logoRodapeTitulo: '',
      logoRodapeLink: ''
    };
  },
  created: function created() {
    var me = this;
    me.client = __WEBPACK_IMPORTED_MODULE_0__main_js__["default"].CLIENT;
    me.tituloRodape = __WEBPACK_IMPORTED_MODULE_0__main_js__["default"].clientData.footer.footerTitle;
    me.descricaoRodape = __WEBPACK_IMPORTED_MODULE_0__main_js__["default"].clientData.footer.footerDescription;
    me.logoRodape = __webpack_require__("+jSN")("./" + me.client + '/rodapeLogo.png');
    me.logoRodapeTitulo = __WEBPACK_IMPORTED_MODULE_0__main_js__["default"].clientData.footer.footerLogoTitle;
    me.logoRodapeTitulo = __WEBPACK_IMPORTED_MODULE_0__main_js__["default"].clientData.footer.footerLink;
  },

  computed: {
    logoRodapeClient: function logoRodapeClient() {
      return this.client === 'DOE-AL' ? 'logoRodapeDOEAL' : 'logoRodapeAll';
    }
  }
});

/***/ }),

/***/ "gX4K":
/***/ (function(module, exports) {

module.exports = {"name":"Diário Oficial Eletrônico - TCE/AL","titleMobile":"Diário Oficial do Tribunal de Contas de Alagoas","home":{"title":"Diário Oficial Eletrônico - TCE / AL"},"spotlight":{"title":"Confira a última edição do Diário Oficial Eletrônico","description":"Visualize a última edição na íntegra, clique no botão abaixo para acessá-la."},"about":{"title":"Sobre o Diario Oficial Eletronico","text":"<p>O Diario Oficial Eletronico, foi criada pela Lei n°1234, de 10 de maio de 2011, na gestão do Diretor XYZ, estando subordinado diretamente ao Departamento de Tecnologia de Informação, ...</p><p>....</p><p>....</p>","contactText":"Entre em contato com o TCE, preencha o formulário abaixo:"},"footer":{"footerTitle":"Tribunal de Contas do Estado de Alagoas","footerDescription":"<b>Telefone:</b> (82) 3315-5596<br><b>Horário de Funcionamento:</b> Seg-Sex | 07h às 19h<br>Av. Fernandes Lima, 1047 - Farol • CEP 57057-097 • Maceió, AL","footerLogoTitle":"Tribunal de Contas do Estado de Alagoas","footerLink":"https://www.tceal.tc.br/"},"layout":{"corPrimaria":"#2C2C4B","corPrimariaClara":"#224992","corSecundaria":"#a23234","corRodape":"#23233c","corBordaRodape":"#a23234"}}

/***/ }),

/***/ "i5k2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_topo_vue__ = __webpack_require__("JeC3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_199980d5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_topo_vue__ = __webpack_require__("oy02");
function injectStyle (ssrContext) {
  __webpack_require__("DnHs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_topo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_199980d5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_topo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iEnD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jpNI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"publicarNoDiario"}},[_c('b-row',[_c('div',[_c('b-card-group',{attrs:{"deck":""}},[_c('b-card',{attrs:{"header-tag":"header"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('header',{staticClass:"text-center"},[_vm._v("Publicar no Diário Oficial")])]},proxy:true}])},[_vm._v(" "),_c('b-card-text',{staticClass:"text-justify"},[_vm._v("\n            Se você é representante de órgão da Administração Pública direta\n            ou indireta do Governo do Estado de Alagoas, sua publicação deve\n            ser realizada por meio do Sistema do Diário Oficial do Estado de\n            Alagoas (Doeal).\n          ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary",attrs:{"href":_vm.adminUrl,"target":"_blank"}},[_vm._v("\n            Acesse o sistema do DOEAL\n          ")])],1),_vm._v(" "),_c('b-card',{attrs:{"header":"Para os demais publicadores do Diário Oficial, seguem os passos a seguir:","header-tag":"header"}},[_c('b-card-text',{staticClass:"text-justify mt-3"},[_vm._v("1) Preencha todos os dados solicitados, para cadastro e emissão\n            da fatura;")]),_vm._v(" "),_c('b-card-text',{staticClass:"text-justify"},[_vm._v("2) Anexe o arquivo Microsoft Word, com o texto na seguinte\n            formatação:")]),_vm._v(" "),_c('ul',{staticClass:"lista-formatacao"},[_c('li',[_vm._v("Fonte: Times New Roman;")]),_vm._v(" "),_c('li',[_vm._v("Tamanho da Fonte: 8;")]),_vm._v(" "),_c('li',[_vm._v("Largura do texto: 9,3cm;")]),_vm._v(" "),_c('li',[_vm._v("\n              Espaçamento simples, tanto entre linhas quanto parágrafos;\n            ")])]),_vm._v(" "),_c('b-card-text',{staticClass:"text-justify"},[_vm._v("3) Após o envio do texto, aguarde e-mail de retorno, com o valor\n            e os dados bancários para transferência/depósito;")]),_vm._v(" "),_c('b-card-text',{staticClass:"text-justify"},[_vm._v("4) Só publicamos mediante comprovação de pagamento. Portanto,\n            após realizar o pagamento, é necessário responder o e-mail que\n            contém o orçamento, anexando o comprovante.")]),_vm._v(" "),_c('b-card-text',{staticClass:"text-justify"},[_vm._v("5) Após validação, sua matéria será publicada no próximo dia\n            útil.")]),_vm._v(" "),_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.modal-prevent-closing",modifiers:{"modal-prevent-closing":true}}],attrs:{"variant":"primary"}},[_vm._v("\n            Solicite um orçamento\n          ")])],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"modal",attrs:{"id":"modal-prevent-closing","title":"Preencha os seguintes dados:","size":"lg"},on:{"hidden":_vm.resetForm},scopedSlots:_vm._u([{key:"modal-footer",fn:function(){return [_c('b-button',{staticClass:"mx-3 py-3 btn-modal",attrs:{"size":"lg","type":"button","block":"","variant":"primary","disabled":_vm.formStatus !== null &&
            _vm.formStatus !== 'ERROR' &&
            _vm.formStatus !== 'ERROR-API'},on:{"click":_vm.sendForm}},[_vm._v("\n          Enviar\n        ")]),_vm._v(" "),(_vm.formStatus === 'ERROR')?_c('strong',{staticClass:"mx-auto mt-3 text-danger",attrs:{"id":"status-message-text"}},[_vm._v("\n          Por favor, preencha os campos corretamente.\n        ")]):_vm._e(),_vm._v(" "),(_vm.formStatus === 'ERROR-API')?_c('strong',{staticClass:"ml-auto mt-3 text-danger",attrs:{"id":"status-message-text"}},[_vm._v("\n          Erro ao Publicar no Diário Oficial\n        ")]):_vm._e(),_vm._v(" "),(_vm.formStatus === 'ERROR-API')?_c('span',{staticClass:"mr-auto mt-3 text-danger"},[_vm._v("\n          "+_vm._s(_vm.formResponseMsg !== '' ? ': ' + _vm.formResponseMsg : '')+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.formStatus === 'PENDING')?_c('strong',{staticClass:"mx-auto mt-3 text-secondary",attrs:{"id":"status-message-text"}},[_vm._v("\n          Enviando... "),_c('icon',{attrs:{"name":"spinner","spin":""}})],1):_vm._e(),_vm._v(" "),(_vm.formStatus === 'OK')?_c('strong',{staticClass:"mx-auto mt-3 text-success",attrs:{"id":"status-message-text"}},[_vm._v("\n          Formulário enviado com sucesso\n        ")]):_vm._e()]},proxy:true}])},[_c('form',{ref:"form",staticClass:"p-3"},[_c('b-row',[_c('b-col',{attrs:{"order":"1","cols":"12","md":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"selectPessoa"}},[_vm._v("Sou pessoa:")]),_vm._v(" "),_c('v-select',{class:{
                  'select-valid': !_vm.$v.formulario.pessoaTipo.$invalid,
                  'select-error': _vm.$v.formulario.pessoaTipo.$invalid
                },attrs:{"id":"selectPessoa","placeholder":"Selecione o tipo","options":_vm.tipoPessoa,"state":_vm.inputState(_vm.$v.formulario.pessoaTipo),"aria-describedby":"pessoaInputLiveFeedback"},on:{"input":_vm.togglePersonType},scopedSlots:_vm._u([{key:"no-options",fn:function(ref){
                var search = ref.search;
                var searching = ref.searching;
return [(searching)?[_vm._v("\n                    Nenhum tipo foi encontrado na pesquisa:\n                    "),_c('em',[_vm._v(_vm._s(search))]),_vm._v(".\n                  ")]:_c('span',[_vm._v("\n                    Nenhum tipo foi encontrado nesta consulta.\n                  ")])]}}]),model:{value:(_vm.$v.formulario.pessoaTipo.$model),callback:function ($$v) {_vm.$set(_vm.$v.formulario.pessoaTipo, "$model", $$v)},expression:"$v.formulario.pessoaTipo.$model"}}),_vm._v(" "),(_vm.$v.formulario.pessoaTipo.$invalid)?_c('span',{staticClass:"invalid-custom-feedback"},[_vm._v("\n                Este campo é obrigatório\n              ")]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"order":"2","cols":"12","md":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name-input"}},[_vm._v("Nome completo")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"name-input","state":_vm.inputState(_vm.$v.formulario.nome),"aria-describedby":"nameInputLiveFeedback","placeholder":"Insira seu nome"},model:{value:(_vm.$v.formulario.nome.$model),callback:function ($$v) {_vm.$set(_vm.$v.formulario.nome, "$model", $$v)},expression:"$v.formulario.nome.$model"}}),_vm._v(" "),_c('b-form-invalid-feedback',{attrs:{"id":"nameInputLiveFeedback"}},[(!_vm.$v.formulario.nome.required)?_c('div',{staticClass:"error"},[_vm._v("\n                  Este campo é obrigatório\n                ")]):_vm._e(),_vm._v(" "),(!_vm.$v.formulario.nome.minLength)?_c('span',{staticClass:"error"},[_vm._v("Este campo precisa ter pelo menos\n                  "+_vm._s(_vm.$v.formulario.nome.$params.minLength.min)+"\n                  caracteres")]):_vm._e()]),_vm._v(" "),_c('b-form-valid-feedback')],1)],1),_vm._v(" "),_c('b-col',{attrs:{"order":"1","cols":"12","md":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"cep-input"}},[_vm._v("CEP")]),_vm._v(" "),_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('#####-###'),expression:"'#####-###'"}],attrs:{"id":"cep-input","placeholder":"____-___","state":_vm.inputState(_vm.$v.formulario.cep),"aria-describedby":"cepInputLiveFeedback"},model:{value:(_vm.$v.formulario.cep.$model),callback:function ($$v) {_vm.$set(_vm.$v.formulario.cep, "$model", $$v)},expression:"$v.formulario.cep.$model"}}),_vm._v(" "),_c('b-form-invalid-feedback',{attrs:{"id":"cepInputLiveFeedback"}},[(!_vm.$v.formulario.cep.required)?_c('span',{staticClass:"error"},[_vm._v("Este campo é obrigatório")]):_vm._e(),_vm._v(" "),(!_vm.$v.formulario.cep.minLength)?_c('span',{staticClass:"error"},[_vm._v("Este campo precisa ter pelo menos\n                  "+_vm._s(_vm.$v.formulario.cep.$params.minLength.min)+"\n                  caracteres")]):_vm._e(),_vm._v(" "),(
                    _vm.$v.formulario.cep.required &&
                    _vm.$v.formulario.cep.minLength &&
                    !_vm.$v.formulario.cep.validCEP
                  )?_c('span',{staticClass:"error"},[_vm._v("CEP inválido")]):_vm._e()]),_vm._v(" "),_c('b-form-valid-feedback')],1)],1),_vm._v(" "),_c('b-col',{attrs:{"order":"2","cols":"12","md":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"endereco-input"}},[_vm._v("Rua/Logradouro")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"endereco-input","state":_vm.inputState(_vm.$v.formulario.endereco),"readonly":"","aria-describedby":"enderecoInputLiveFeedback"},model:{value:(_vm.$v.formulario.endereco.$model),callback:function ($$v) {_vm.$set(_vm.$v.formulario.endereco, "$model", $$v)},expression:"$v.formulario.endereco.$model"}}),_vm._v(" "),_c('b-form-invalid-feedback',{attrs:{"id":"enderecoInputLiveFeedback"}},[(!_vm.$v.formulario.endereco.required)?_c('div',{staticClass:"error"},[_vm._v("\n                  Este campo é obrigatório\n                ")]):_vm._e()]),_vm._v(" "),_c('b-form-valid-feedback')],1)],1),_vm._v(" "),_c('b-col',{attrs:{"order":"3","cols":"12","md":"6"}},[(_vm.formulario.pessoaTipo != 'Jurídica')?[_c('b-form-group',[_c('label',{attrs:{"for":"cpf-input"}},[_vm._v("CPF")]),_vm._v(" "),_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('###.###.###-##'),expression:"'###.###.###-##'"}],attrs:{"id":"cpf-input","placeholder":"___.___.___-__","state":_vm.inputState(_vm.$v.formulario.cpf),"aria-describedby":"cpfInputLiveFeedback","disabled":_vm.formulario.pessoaTipo == null},model:{value:(_vm.$v.formulario.cpf.$model),callback:function ($$v) {_vm.$set(_vm.$v.formulario.cpf, "$model", $$v)},expression:"$v.formulario.cpf.$model"}}),_vm._v(" "),_c('b-form-invalid-feedback',{attrs:{"id":"cpfInputLiveFeedback"}},[(!_vm.$v.formulario.cpf.required)?_c('span',{staticClass:"error"},[_vm._v("Este campo é obrigatório")]):_vm._e(),_vm._v(" "),(!_vm.$v.formulario.cpf.minLength)?_c('span',{staticClass:"error"},[_vm._v("Este campo precisa ter pelo menos\n                    "+_vm._s(_vm.$v.formulario.cpf.$params.minLength.min)+"\n                    caracteres")]):_vm._e(),_vm._v(" "),(
                      _vm.$v.formulario.cpf.required &&
                      _vm.$v.formulario.cpf.minLength &&
                      !_vm.$v.formulario.cpf.validCPF
                    )?_c('span',{staticClass:"error"},[_vm._v("CPF inválido")]):_vm._e()]),_vm._v(" "),_c('b-form-valid-feedback')],1)]:_vm._e(),_vm._v(" "),(_vm.formulario.pessoaTipo == 'Jurídica')?[_c('b-form-group',[_c('label',{attrs:{"for":"cnpj-input"}},[_vm._v("CNPJ")]),_vm._v(" "),_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##.###.###/####-##'),expression:"'##.###.###/####-##'"}],attrs:{"id":"cnpj-input","placeholder":"__.___.___/____-__","state":_vm.inputState(_vm.$v.formulario.cnpj),"aria-describedby":"cnpjInputLiveFeedback"},model:{value:(_vm.$v.formulario.cnpj.$model),callback:function ($$v) {_vm.$set(_vm.$v.formulario.cnpj, "$model", $$v)},expression:"$v.formulario.cnpj.$model"}}),_vm._v(" "),_c('b-form-invalid-feedback',{attrs:{"id":"cnpjInputLiveFeedback"}},[(!_vm.$v.formulario.cnpj.required)?_c('div',{staticClass:"error"},[_vm._v("\n                    Este campo é obrigatório\n                  ")]):_vm._e(),_vm._v(" "),(!_vm.$v.formulario.cnpj.minLength)?_c('span',{staticClass:"error"},[_vm._v("Este campo precisa ter pelo menos\n                    "+_vm._s(_vm.$v.formulario.cnpj.$params.minLength.min)+"\n                    caracteres")]):_vm._e(),_vm._v(" "),(
                      _vm.$v.formulario.cnpj.required &&
                      _vm.$v.formulario.cnpj.minLength &&
                      !_vm.$v.formulario.cnpj.validCNPJ
                    )?_c('span',{staticClass:"error"},[_vm._v("CNPJ inválido")]):_vm._e()]),_vm._v(" "),_c('b-form-valid-feedback')],1)]:_vm._e()],2),_vm._v(" "),_c('b-col',{attrs:{"order":"3","cols":"12","md":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"numero-input"}},[_vm._v("Número")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"numero-input","placeholder":"ex: 32","type":"number","min":"1","state":_vm.inputState(_vm.$v.formulario.numero),"aria-describedby":"numeroInputLiveFeedback"},model:{value:(_vm.$v.formulario.numero.$model),callback:function ($$v) {_vm.$set(_vm.$v.formulario.numero, "$model", $$v)},expression:"$v.formulario.numero.$model"}}),_vm._v(" "),_c('b-form-invalid-feedback',{attrs:{"id":"numeroInputLiveFeedback"}},[(!_vm.$v.formulario.numero.required)?_c('div',{staticClass:"error"},[_vm._v("\n                  Este campo é obrigatório\n                ")]):_vm._e()]),_vm._v(" "),_c('b-form-valid-feedback')],1)],1),_vm._v(" "),_c('b-col',{attrs:{"order":"4","cols":"12","md":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"telefone-input"}},[_vm._v("Telefone")]),_vm._v(" "),_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:(['(##) ####-####', '(##) #####-####']),expression:"['(##) ####-####', '(##) #####-####']"}],attrs:{"id":"telefone-input","placeholder":"(__) _____-____","state":_vm.inputState(_vm.$v.formulario.telefone),"aria-describedby":"telefoneInputLiveFeedback"},model:{value:(_vm.$v.formulario.telefone.$model),callback:function ($$v) {_vm.$set(_vm.$v.formulario.telefone, "$model", $$v)},expression:"$v.formulario.telefone.$model"}}),_vm._v(" "),_c('b-form-invalid-feedback',{attrs:{"id":"telefoneInputLiveFeedback"}},[(!_vm.$v.formulario.telefone.required)?_c('div',{staticClass:"error"},[_vm._v("\n                  Este campo é obrigatório\n                ")]):_vm._e(),_vm._v(" "),(!_vm.$v.formulario.telefone.minLength)?_c('span',{staticClass:"error"},[_vm._v("Este campo precisa ter pelo menos\n                  "+_vm._s(_vm.$v.formulario.telefone.$params.minLength.min)+"\n                  caracteres")]):_vm._e()]),_vm._v(" "),_c('b-form-valid-feedback')],1)],1),_vm._v(" "),_c('b-col',{attrs:{"order":"4","cols":"12","md":"6"}},[_c('b-form-group',{attrs:{"label":"Complemento","label-for":"complemento-input"}},[_c('b-form-input',{attrs:{"id":"complemento-input"},model:{value:(_vm.formulario.complemento),callback:function ($$v) {_vm.$set(_vm.formulario, "complemento", $$v)},expression:"formulario.complemento"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"order":"5","cols":"12","md":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"email-input"}},[_vm._v("E-Mail")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"email-input","placeholder":"exemplo@email.com","state":_vm.inputState(_vm.$v.formulario.email),"aria-describedby":"emailInputLiveFeedback"},model:{value:(_vm.$v.formulario.email.$model),callback:function ($$v) {_vm.$set(_vm.$v.formulario.email, "$model", $$v)},expression:"$v.formulario.email.$model"}}),_vm._v(" "),_c('b-form-invalid-feedback',{attrs:{"id":"emailInputLiveFeedback"}},[(!_vm.$v.formulario.email.required)?_c('div',{staticClass:"error"},[_vm._v("\n                  Este campo é obrigatório\n                ")]):_vm._e(),_vm._v(" "),(!_vm.$v.formulario.email.email)?_c('span',{staticClass:"error"},[_vm._v("E-mail inválido")]):_vm._e()]),_vm._v(" "),_c('b-form-valid-feedback')],1)],1),_vm._v(" "),_c('b-col',{attrs:{"order":"5","cols":"12","md":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"bairro-input"}},[_vm._v("Bairro")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"bairro-input","state":_vm.inputState(_vm.$v.formulario.bairro),"readonly":"","aria-describedby":"bairroInputLiveFeedback"},model:{value:(_vm.$v.formulario.bairro.$model),callback:function ($$v) {_vm.$set(_vm.$v.formulario.bairro, "$model", $$v)},expression:"$v.formulario.bairro.$model"}}),_vm._v(" "),_c('b-form-invalid-feedback',{attrs:{"id":"bairroInputLiveFeedback"}},[(!_vm.$v.formulario.bairro.required)?_c('div',{staticClass:"error"},[_vm._v("\n                  Este campo é obrigatório\n                ")]):_vm._e()]),_vm._v(" "),_c('b-form-valid-feedback')],1)],1),_vm._v(" "),_c('b-col',{attrs:{"order":"7","cols":"12","md":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"cidade-input"}},[_vm._v("Cidade")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"cidade-input","state":_vm.inputState(_vm.$v.formulario.cidade),"readonly":"","aria-describedby":"cidadeInputLiveFeedback"},model:{value:(_vm.$v.formulario.cidade.$model),callback:function ($$v) {_vm.$set(_vm.$v.formulario.cidade, "$model", $$v)},expression:"$v.formulario.cidade.$model"}}),_vm._v(" "),_c('b-form-invalid-feedback',{attrs:{"id":"cidadeInputLiveFeedback"}},[(!_vm.$v.formulario.cidade.required)?_c('div',{staticClass:"error"},[_vm._v("\n                  Este campo é obrigatório\n                ")]):_vm._e()]),_vm._v(" "),_c('b-form-valid-feedback')],1)],1),_vm._v(" "),_c('b-col',{attrs:{"order":"8","cols":"12","md":"6"}}),_vm._v(" "),_c('b-col',{attrs:{"order":"8","cols":"12","md":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"selectUF"}},[_vm._v("Estado")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"selectUF","state":_vm.inputState(_vm.$v.formulario.uf),"readonly":"","aria-describedby":"ufInputLiveFeedback","placeholder":"Insira o estado"},model:{value:(_vm.$v.formulario.uf.$model),callback:function ($$v) {_vm.$set(_vm.$v.formulario.uf, "$model", $$v)},expression:"$v.formulario.uf.$model"}}),_vm._v(" "),_c('b-form-invalid-feedback',{attrs:{"id":"ufInputLiveFeedback"}},[(!_vm.$v.formulario.uf.required)?_c('div',{staticClass:"error"},[_vm._v("\n                  Este campo é obrigatório\n                ")]):_vm._e()]),_vm._v(" "),_c('b-form-valid-feedback')],1)],1),_vm._v(" "),_c('b-col',{attrs:{"order":"6","cols":"12","md":"6"}},[_c('b-form-group',{attrs:{"state":_vm.fileState}},[_c('label',{attrs:{"for":"arquivos-input"}},[_vm._v("Arquivos")]),_vm._v(" "),_c('b-form-file',{attrs:{"id":"arquivos-input","state":_vm.inputState(_vm.$v.formulario.arquivos),"aria-describedby":"arquivosInputLiveFeedback","placeholder":"Somente arquivos .doc e .docx","accept":".doc, .docx"},model:{value:(_vm.$v.formulario.arquivos.$model),callback:function ($$v) {_vm.$set(_vm.$v.formulario.arquivos, "$model", $$v)},expression:"$v.formulario.arquivos.$model"}}),_vm._v(" "),_c('b-form-invalid-feedback',{attrs:{"id":"arquivosInputLiveFeedback"}},[(_vm.$v.formulario.arquivos.$invalid)?_c('div',[_c('span',{staticClass:"error"},[_vm._v("Este campo é obrigatório")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"error"},[_vm._v("Somente arquivos .doc e .docx são permitidos")])]):_vm._e()]),_vm._v(" "),_c('b-form-valid-feedback')],1)],1)],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jzIP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"editions-page"}},[_c('b-row',{staticClass:"tituloPaginaRow",style:(_vm.tituloRowBG)},[_c('h1',{staticClass:"tituloPagina text-center tituloIntro"},[_vm._v("\n      "+_vm._s(_vm.tituloPagina)+"\n    ")])]),_vm._v(" "),_c('b-row',{staticClass:"p-3 p-sm-0"},[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{attrs:{"id":"arvore"}},[_c('div',{attrs:{"id":"decades-row"}},[_c('div',{attrs:{"id":"decades"}},_vm._l((_vm.decades),function(decade,index){return _c('div',{key:index},[_c('b-button',{staticClass:"periodButton",class:decade.activeMenu ? 'menu-active' : '',attrs:{"type":"button","variant":"cinzaClaro","id":decade.id},on:{"click":function($event){return _vm.loadYears(decade)}}},[_vm._v(_vm._s(decade.title))])],1)}),0)]),_vm._v(" "),_c('div',{attrs:{"id":"years-row"}},[_c('div',{attrs:{"id":"years"}},_vm._l((_vm.years),function(year,index){return _c('div',{key:index},[_c('b-button',{staticClass:"periodButton",class:year.activeMenu ? 'menu-active' : '',attrs:{"type":"button","variant":"cinzaClaro","id":year.id},on:{"click":function($event){return _vm.loadMonths(year)}}},[_vm._v("Ano "+_vm._s(year.title))])],1)}),0)]),_vm._v(" "),_c('div',{attrs:{"id":"months-row"}},[_c('div',{attrs:{"id":"months"}},_vm._l((_vm.months),function(month,index){return _c('div',{key:index},[_c('b-button',{staticClass:"periodButton",class:month.activeMenu ? 'menu-active' : '',attrs:{"type":"button","variant":"cinzaClaro","id":month.id,"name":"button"},on:{"click":function($event){return _vm.loadEditions(month, index)}}},[_vm._v(_vm._s(month.title))])],1)}),0)])])])],1),_vm._v(" "),_c('b-row',{staticClass:"text-center"},[_c('b-col',{staticClass:"mt-sm-2 mb-sm-8",attrs:{"cols":"12","sm":"12","md":"12","lg":"12","xl":"12"}},[(_vm.editionsLoaded && !_vm.editionIsLoading)?[(_vm.items.length)?[_c('div',{staticClass:"tipo-editions"},[_c('strong',[_vm._v("Mês Selecionado:\n              "),_c('i',{staticClass:"themecolor"},[_vm._v(_vm._s(_vm.activeMonthName)+" de "+_vm._s(_vm.activeYearName))])])]),_vm._v(" "),_c('h4',{staticClass:"text-center mt-4"},[_vm._v("Publicações")]),_vm._v(" "),_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.items,"fields":_vm.fields,"per-page":_vm.perPage},scopedSlots:_vm._u([{key:"cell(number)",fn:function(data){return [_vm._v("\n              "+_vm._s(data.item['edition_type_name'])+" №\n              "+_vm._s(data.item['number'])+"\n              "+_vm._s(_vm._f("formatSuplement")(data.item['suplement']))+"\n            ")]}},{key:"cell(publication_date)",fn:function(data){return [_vm._v("\n              "+_vm._s(_vm._f("formatDate")(data.item['publication_date']))+"\n            ")]}},{key:"cell(acoes)",fn:function(data){return [_c('b-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"target":"_blank","href":_vm.viewEdition(data.item.id),"title":"Ver Edição"}},[_c('icon',{attrs:{"name":"eye"}})],1),_vm._v(" "),_c('b-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"href":_vm.downloadEdition(data.item.id),"title":"Baixar edição"}},[_c('icon',{attrs:{"name":"download"}})],1)]}}],null,false,3881278674)})]:_c('div',{staticClass:"message"},[_c('strong',[_vm._v("Não existem edições publicadas nesse mês, por favor selecione\n            outra data.")])])]:(_vm.editionIsLoading)?[_c('div',{staticClass:"message"},[_c('strong',[_vm._v("\n            Carregando listagem\n            "),_c('icon',{attrs:{"name":"spinner","spin":""}})],1)])]:[_c('div',{staticClass:"message"},[_c('strong',[_vm._v("Selecione acima a data da edição para a exibição da\n            listagem")])])]],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kN49":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kmPt":
/***/ (function(module, exports) {

module.exports = {"name":"Gazeta Municipal - Prefeitura de Cuiabá","titleMobile":"Gazeta Municipal","home":{"title":"Gazeta Municipal"},"spotlight":{"title":"Confira a última edição da Gazeta Municipal","description":"Visualize a última edição na íntegra, clique no botão abaixo para acessá-la."},"about":{"title":"Sobre a Gazeta Municipal","text":"<p>O Jornal da Municipalidade, denominado “Gazeta Municipal” foi criada pela Lei n°679, de 10 de maio de 1963, na gestão do Prefeito Vicente Emilio Vuolo, estando subordinado diretamente ao Departamento de relações Públicas, sendo criados os cargos de Redator Secretário, Chefe de Publicidade e Auxiliar Redação (revisão).</p><p>O exemplar mais antigo recuperado e virtualizado é do ano de 1967, circulou com 12 páginas no dia 14 de Dezembro de 1967, era a edição de número 086 - ano IV e em sua última página faz menção sobre os 250 anos de Cuiabá que seria comemorado em 08 de Abril de 1.969.</p><p>A Gazeta Municipal permaneceu ativa até o ano de 2013 quando por questões de custos foi inativada. Hoje, passado 07 anos, é retornada totalmente eletronica, passando a ser mais uma vez o instrumento oficial de publicação dos atos, continuando firme em sua missão de divulgar os atos oficiais, representando a transparência do Poder Executivo.</p>","contactText":"Entre em contato com a Prefeitura, preencha o formulário abaixo:"},"footer":{"footerTitle":"Prefeitura Municipal de Cuiabá","footerDescription":"<b>Telefone:</b> (65) 3645-6263/6039 (Recepção)<br><b>Horário de Funcionamento:</b> 08h às 12h | 14h às 18h<br>Praça Alencastro, 158 - Centro • CEP 78005-906 • Cuiabá, MT","footerLogoTitle":"SMGE Secretaria de Gestão","footerLink":"http://www.cuiaba.mt.gov.br/"},"layout":{"corPrimaria":"#007c28","corPrimariaClara":"#0b9e35","corSecundaria":"#f4e200","corRodape":"#C3B500","corBordaRodape":"#007c28"}}

/***/ }),

/***/ "ks4e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l2uB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Busca_vue__ = __webpack_require__("vpMu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73df0424_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Busca_vue__ = __webpack_require__("PpCb");
function injectStyle (ssrContext) {
  __webpack_require__("kN49")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Busca_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73df0424_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Busca_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c06518e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("vxyb");
function injectStyle (ssrContext) {
  __webpack_require__("zkds")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c06518e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mF9N":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./CUIABA/gazetaTopo1.png": "pnxH",
	"./DOE-AL/gazetaTopo1.png": "cc0X",
	"./PMVG/gazetaTopo1.png": "Z+Yt",
	"./TCE-AL/gazetaTopo1.png": "qDLD"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mF9N";

/***/ }),

/***/ "muQP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rodape_vue__ = __webpack_require__("gPVK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87c9ca6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rodape_vue__ = __webpack_require__("NoUH");
function injectStyle (ssrContext) {
  __webpack_require__("spK8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rodape_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87c9ca6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rodape_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nd1H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oy02":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{style:(_vm.fundoTopo),attrs:{"fluid":"","id":"topo"}},[(_vm.client === 'CUIABA')?_c('div',{staticClass:"d-block",attrs:{"id":"containerLogin"}},[_c('b-form',{staticClass:"text-right",attrs:{"id":"formLogin"}},[_c('b-col',{staticClass:"campoLogin",attrs:{"cols":"12","sm":"12","md":"12","lg":"12","xl":"12"}},[_c('b-form-group',{staticClass:"mb-0 mt-2"},[_c('a',{staticClass:"btn px-md-3 py-md-2 mt-md-0 btn-primary",attrs:{"href":_vm.baseLink,"title":"Login","target":"_blank"}},[_vm._v("\n            Acessar Admin\n          ")])])],1)],1)],1):_vm._e(),_vm._v(" "),_c('menuSite'),_vm._v(" "),_c('destaque')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pnxH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gazetaTopo1.45bf1db.png";

/***/ }),

/***/ "qDLD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gazetaTopo1.e16e234.png";

/***/ }),

/***/ "qJ/2":
/***/ (function(module, exports) {

module.exports = {"name":"Diário Oficial Eletrônico","titleMobile":"Diário Oficial Eletrônico","home":{"title":"Diário Oficial Eletrônico"},"spotlight":{"title":"Confira a última edição do Diário Oficial Eletrônico","description":"Visualize a última edição na íntegra. Clique no botão abaixo para acessá-la."},"about":{"title":"Sobre o Diário Oficial","text":"<p>O Diário Oficial do Estado de Alagoas (Doeal) teve sua primeira edição em 17 de janeiro de 1912, por meio da criação da Imprensa Oficial, instituída pelo Decreto nº 537, do governador Euclides Vieira Malta, tornando-se a primeira ferramenta de transparência no âmbito das políticas públicas em solo alagoano. Atualmente,  o  Doeal  é  disciplinado  pela <a href='https://www.imprensaoficial.al.gov.br/themes/institutional/assets/pdf/lei-n-7397-de-03-de-agosto-de-2012-disciplina-o-diario-oficial-do-estado-de-alagoas.pdf?v=1650712913' target='_blank'><b>Lei  nº  7.397,  de  03  de  agosto  de  2012</b></a>,  como instrumento   de   publicação   dos   atos   oficiais,   normativos,   administrativos,   processuais   e   de comunicação  em  geral  dos  Poderes  Constituídos,  órgãos  e  entidades  do  Estado  de  Alagoas  e  dos Municípios alagoanos, bem como dos atos de interesse de particulares e dos que requerem publicidade legal obrigatória ou que, por lei, devam ser publicados em órgãos oficiais.</p>Qualidade e eficiência em 2018, o Diário Oficial do Estado de Alagoas conquistou o selo ISO 9001:2015, atestado pela Bureau  Veritas  Certification,  tornando-se  o  2º  do  Nordeste  com  a  certificação  de  qualidade.  O certificado  reflete  o  compromisso  com  a  padronização  dos  processos  e  com  o  aprimoramento  da gestão interna, o que garante ao nosso cliente a qualidade do produto e dos serviços prestados pela instituição. A ascensão, o fortalecimento e a relevância do Doeal, no cenário internacional, tornou Alagoas a sede da Reunião da Associação Brasileira de Imprensas Oficiais (Abio) e da Red de Boletines Oficiales de  América  (RedBoa),  em  2019.  O  evento  reuniu  gestores  e  representantes  de  diversos  estados  e nacionalidades com  o  objetivo  de  apresentar  e  discutir  os  novos  rumos  e  diretrizes  das  imprensas oficiais, no Brasil e na América Latina.<p></p>","contactText":"Entre em contato com o TCE, preencha o formulário abaixo:"},"footer":{"footerTitle":"Diário Oficial Eletrônico","footerDescription":"<b>Informações de contatos:</b><br>(82) 3315-8300<br><br><b>Nos envie um e-mail:</b><br>materias@imprensaoficial-al.com.br<br><br><b>Horário de Funcionamento:</b><br>Segunda a sexta-feira | 8h às 17h<br><br><b>Venha nos visitar:</b><br>Av. Fernandes Lima, s/n, Km 7, Gruta de Lourdes, Maceió/Alagoas<br>Brasil - Cep 57.055-000","footerLogoTitle":"Diario Oficial Eletrônico","footerLink":"materias@imprensaoficial-al.com.br"},"layout":{"corPrimaria":"#2C3352","corPrimariaClara":"#506690","corSecundaria":"#ED3050","corRodape":"#161C2D","corBordaRodape":"#ED3050"}}

/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qp3q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerEdicao_vue__ = __webpack_require__("Q9cC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_349504ad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerEdicao_vue__ = __webpack_require__("VMis");
function injectStyle (ssrContext) {
  __webpack_require__("CG5S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-349504ad"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerEdicao_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_349504ad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerEdicao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sHGW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sbqc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuscaItem_vue__ = __webpack_require__("VMjJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c980dab_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuscaItem_vue__ = __webpack_require__("IA//");
function injectStyle (ssrContext) {
  __webpack_require__("tBDc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuscaItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c980dab_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuscaItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "spK8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tBDc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tbNJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.e3ec2c1.png";

/***/ }),

/***/ "uYzE":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAZCAYAAAAbp/98AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAABlJREFUeNpiYKAfYGSo0fgPYjDR0VKAAAMAvEEBp0bIa8AAAAAASUVORK5CYII="

/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mutations; });
var state = {
  searchData: ''
};

var mutations = {
  populateSearch: function populateSearch(state, type) {
    state.searchData = type;
  }
};

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vpMu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_locale_pt_br__ = __webpack_require__("AoDM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_locale_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_locale_pt_br__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BuscaItem__ = __webpack_require__("sbqc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_portal__ = __webpack_require__("ENzL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main_js__ = __webpack_require__("NHnr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BuscaAvancada',
  components: {
    vSelect: __WEBPACK_IMPORTED_MODULE_2_vue_select___default.a,
    buscaItem: __WEBPACK_IMPORTED_MODULE_3__BuscaItem__["a" /* default */]
  },
  data: function data() {
    return {
      client: null,
      totalRows: 0,
      perPage: 15,
      currentPage: 1,
      min_date: '',
      max_date: '',
      items: [],
      tituloPagina: 'Pesquisar Edições',
      tituloResultado: 'Resultados da Busca',
      showResults: false,
      showSearching: false,
      resultOffset: 0,
      resultKeywords: '',
      periodo_inicial: '',
      periodo_final: '',
      searchTypeOptions: [{ title: 'Todas as palavras', value: 'toda_palavra' }, { title: 'Frase exata', value: 'frase_exata' }, { title: 'Qualquer palavra', value: 'qualquer_palavra' }],
      orderOptions: [{ title: 'Mais antiga', value: 'antigo' }, { title: 'Mais nova', value: 'novo' }, { title: 'Por relevância', value: 'relevancia' }],
      formBusca: {
        keywords: '',
        range: [],
        edition_number: '',
        searchType: {
          title: 'Frase exata',
          value: 'frase_exata'
        },
        order: {
          title: 'Mais nova',
          value: 'novo'
        }
      },
      filtroVeiculo: [],
      filtroVeiculoSelected: [],
      filtroTipoEdicao: [],
      filtroTipoEdicaoSelected: [],
      filtroAnoPublicacao: [],
      filtroAnoPublicacaoSelected: [],
      disableClearFilters: true
    };
  },
  created: function created() {
    var me = this;
    me.client = __WEBPACK_IMPORTED_MODULE_5__main_js__["default"].CLIENT;
    me.tituloRowBG = {
      backgroundImage: 'url(' + __webpack_require__("9wcz")("./" + me.client + '/tituloPagFdo.png') + ')'
    };
  },
  mounted: function mounted() {
    this.loadDataSearch();
  },

  methods: {
    loadDataSearch: function loadDataSearch() {
      var me = this;
      var searchData = this.$store.state.searchData;
      if (typeof searchData.palavra_chave === 'undefined') return false;
      me.formBusca.keywords = searchData.palavra_chave;
      me.periodo_inicial = searchData.periodo_inicial;
      me.periodo_final = searchData.periodo_final;
      me.formBusca.edition_number = searchData.edition_number;
      me.formBusca.searchType = searchData.searchType;
      me.formBusca.order = searchData.order;

      me.fetchEditions();
      me.showResults = true;
      // limpando store
      me.$store.commit('populateSearch', null);
    },
    getResultTop: function getResultTop() {
      var resultArea = document.getElementById('areaResultados');
      this.resultOffset = resultArea.offsetTop;
    },
    scrollTop: function scrollTop() {
      var timeOut = void 0;
      var me = this;
      if (document.body.scrollTop > me.resultOffset || document.documentElement.scrollTop > me.resultOffset) {
        window.scrollBy(0, -30);
        timeOut = setTimeout(me.scrollTop, 10);
      } else clearTimeout(timeOut);
    },
    changePage: function changePage() {
      this.getResultTop();
      this.fetchEditions(this.currentPage);
      this.scrollTop();
    },
    onResetSearch: function onResetSearch(evt) {
      evt.preventDefault();
      /* Limpar os campos do formulario */
      this.formBusca.keywords = '';
      this.periodo_inicial = '';
      this.periodo_final = '';
      this.formBusca.edition_number = '';
      this.formBusca.searchType = 'frase_exata';
      this.formBusca.order = 'novo';
      this.showResults = false;
      this.showSearching = false;
    },
    clearFilters: function clearFilters() {
      /* Limpar os campos do filtro */
      this.filtroVeiculoSelected = [];
      this.filtroTipoEdicaoSelected = [];
      this.filtroAnoPublicacaoSelected = [];
      this.showSearching = false;
      this.search();
    },
    changeFilters: function changeFilters() {
      if (this.filtroVeiculoSelected.length || this.filtroTipoEdicaoSelected.length || this.filtroAnoPublicacaoSelected.length) {
        this.disableClearFilters = false;
      } else {
        this.disableClearFilters = true;
      }
      this.search();
    },
    search: function search() {
      this.currentPage = 1;
      this.showResults = false;
      this.fetchEditions();
    },
    fetchEditions: function fetchEditions() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      var me = this;

      me.showSearching = true;
      me.formBusca.range = [me.periodo_inicial, me.periodo_final];
      me.resultKeywords = me.formBusca.keywords;

      var dataBusca = {
        keywords: me.formBusca.keywords,
        range: me.formBusca.range,
        edition_number: me.formBusca.edition_number,
        searchType: '',
        order: ''
      };

      dataBusca.searchType = me.formBusca.searchType && me.formBusca.searchType.value ? me.formBusca.searchType.value : 'frase_exata';
      dataBusca.order = me.formBusca.order && me.formBusca.order.value ? me.formBusca.order.value : 'novo';

      if (me.filtroVeiculoSelected.length) {
        dataBusca.edition_type_name = me.filtroVeiculoSelected[0];
      }

      if (me.filtroTipoEdicaoSelected.length) {
        dataBusca.is_suplement = me.filtroTipoEdicaoSelected[0];
      }

      if (me.filtroAnoPublicacaoSelected.length) {
        dataBusca.filter_year = me.filtroAnoPublicacaoSelected[0];
        // dataBusca.filter_year = me.filtroAnoPublicacaoSelected
      }

      var promise = __WEBPACK_IMPORTED_MODULE_4__api_portal__["a" /* default */].searchEditions(page, dataBusca);

      promise.then(function (data) {
        me.totalRows = data.total_rows.value;
        me.min_date = data.min_date;
        me.max_date = data.max_date;
        me.items = data.items;
        me.filtroVeiculo = data.edition_type_name;
        me.filtroTipoEdicao = data.is_suplement;
        me.filtroAnoPublicacao = data.filter_year;

        me.showResults = true;
        me.showSearching = false;
      });
    }
  },
  filters: {
    formatDate: function formatDate(value) {
      if (value) {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(String(value)).format('LL');
      }
      return '-';
    }
  }
});

/***/ }),

/***/ "vwlZ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAZCAYAAAAbp/98AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAB5JREFUeNpiYKA5YNTR8W4AMViAuB7GaGSgDwAIMAD9LwItt0tTqAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "vxyb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('b-row',{staticClass:"tituloPaginaRow",style:(_vm.tituloRowBG)},[_c('h1',{staticClass:"tituloPagina text-center tituloIntro"},[_vm._v("\n      "+_vm._s(_vm.tituloPagina)+"\n    ")])]),_vm._v(" "),_c('b-row',{staticClass:"p-3 p-sm-0 p-md-0 p-lg-0 p-xl-0"},[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"5","xl":"5","id":"colunaLogin"}},[_c('h4',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.tituloBusca))]),_vm._v(" "),_c('b-row',[_c('b-form',{staticClass:"mb-4 mb-sm-0 mb-md-0 mb-lg-0 mb-xl-0",attrs:{"id":"formBusca"},on:{"submit":_vm.onSubmitBusca,"reset":_vm.onResetBusca}},[(_vm.client === 'DOE-AL')?_c('p',[_vm._v("\n            Realize sua busca, utilizando o critério desejado. Para isso,\n            preencha qualquer um dos campos abaixo.\n          ")]):_c('p',[_vm._v("\n            Busque nas edições publicadas usando o critério desejado\n            preenchendo qualquer um dos campos abaixo.\n          ")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"id":"inputGrupoPalavraChave"}},[_c('b-form-input',{attrs:{"id":"inputPalavraChave","type":"text","placeholder":"Buscar por: (Qualquer palavra...)"},model:{value:(_vm.formBusca.palavra_chave),callback:function ($$v) {_vm.$set(_vm.formBusca, "palavra_chave", $$v)},expression:"formBusca.palavra_chave"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"inputGrupoPeriodoInicial","label":"Período inicial:","label-for":"inputPeriodoInicial"}},[_c('b-form-input',{attrs:{"id":"inputPeriodoInicial","type":"date","placeholder":"Período inicial ..."},model:{value:(_vm.formBusca.periodo_inicial),callback:function ($$v) {_vm.$set(_vm.formBusca, "periodo_inicial", $$v)},expression:"formBusca.periodo_inicial"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"id":"inputGrupoPeriodoFinal","label":"Período final:","label-for":"inputPeriodoFinal"}},[_c('b-form-input',{attrs:{"id":"inputPeriodoFinal","type":"date","placeholder":"Período final ..."},model:{value:(_vm.formBusca.periodo_final),callback:function ($$v) {_vm.$set(_vm.formBusca, "periodo_final", $$v)},expression:"formBusca.periodo_final"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"inputGrupoNumeroEdicao","label":"Número da Edição:","label-for":"inputNumeroEdicao"}},[_c('b-form-input',{attrs:{"id":"inputNumeroEdicao","type":"text","placeholder":"Número da Edição ..."},model:{value:(_vm.formBusca.edition_number),callback:function ($$v) {_vm.$set(_vm.formBusca, "edition_number", $$v)},expression:"formBusca.edition_number"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"selectGrupoBuscaTipo","label":"Buscar por:","label-for":"selectBuscaTipo"}},[_c('v-select',{attrs:{"id":"selectBuscaTipo","placeholder":"Selecione o tipo da busca","label":"title","options":_vm.searchTypeOptions},model:{value:(_vm.formBusca.searchType),callback:function ($$v) {_vm.$set(_vm.formBusca, "searchType", $$v)},expression:"formBusca.searchType"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"id":"selectGrupoOrdenacao","label":"Ordenar por:","label-for":"selectOrdenacao"}},[_c('v-select',{attrs:{"id":"selectOrdenacao","placeholder":"Selecione a ordenação da busca","label":"title","options":_vm.orderOptions},model:{value:(_vm.formBusca.order),callback:function ($$v) {_vm.$set(_vm.formBusca, "order", $$v)},expression:"formBusca.order"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{staticClass:"float-right"},[_c('b-button',{attrs:{"type":"reset","variant":"cinzaClaro"}},[_vm._v("Limpar")]),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v("Buscar")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"mb-sm-6",attrs:{"cols":"12","sm":"12","md":"12","lg":"6","xl":"6","offset-lg":"1","offset-xl":"1","id":"colunaPublicacoes"}},[_c('h4',{staticClass:"text-center"},[_vm._v("Publicações")]),_vm._v(" "),_c('b-row',[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.items,"fields":_vm.fields,"per-page":_vm.perPage},scopedSlots:_vm._u([{key:"cell(number)",fn:function(data){return [_c('span',{staticClass:"editionName"},[_vm._v(_vm._s(data.item['edition_type_name'])+" "+_vm._s(data.item['number'])+"\n              "+_vm._s(_vm._f("formatSuplement")(data.item['suplement'])))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"downloads"},[_c('icon',{attrs:{"name":"download"}}),_vm._v("\n              "+_vm._s(data.item['downloads'])+" downloads")],1)]}},{key:"cell(publication_date)",fn:function(data){return [_vm._v("\n            "+_vm._s(_vm._f("formatDate")(data.item['publication_date']))+"\n          ")]}},{key:"cell(acoes)",fn:function(data){return [_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"href":_vm.viewEdition(data.item.id),"target":"_blank","title":"Ver Edição"}},[_c('icon',{attrs:{"name":"eye"}})],1),_vm._v(" "),_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"href":_vm.downloadEdition(data.item.id),"title":"Baixar edição"}},[_c('icon',{attrs:{"name":"download"}})],1)]}}])})],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-right",attrs:{"cols":"12"}},[_c('router-link',{attrs:{"to":"/edicoes"}},[_vm._v("Ver edições anteriores")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w/ji":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rodapeLogo.3db158f.png";

/***/ }),

/***/ "w0xu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sobre_vue__ = __webpack_require__("aSWz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd673ea8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sobre_vue__ = __webpack_require__("zmmJ");
function injectStyle (ssrContext) {
  __webpack_require__("wBRL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sobre_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd673ea8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sobre_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wBRL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_topo_vue__ = __webpack_require__("i5k2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_rodape_vue__ = __webpack_require__("muQP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main_js__ = __webpack_require__("NHnr");
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    topo: __WEBPACK_IMPORTED_MODULE_0__components_layout_topo_vue__["a" /* default */],
    rodape: __WEBPACK_IMPORTED_MODULE_1__components_layout_rodape_vue__["a" /* default */]
  },
  data: function data() {
    return {
      client: null
    };
  },
  created: function created() {
    var me = this;
    me.client = __WEBPACK_IMPORTED_MODULE_2__main_js__["default"].CLIENT;
    document.title = __WEBPACK_IMPORTED_MODULE_2__main_js__["default"].clientData.name;
  },

  computed: {
    clientFont: function clientFont() {
      return this.client === 'DOE-AL' ? 'HKGroteskPro, sans-serif !important' : 'Roboto, sans-serif !important';
    }
  }
});

/***/ }),

/***/ "xSFO":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAZCAYAAAAbp/98AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAB5JREFUeNpiYKA5YNTR8W4AMViAuB7GaGSgDwAIMAD9LwItt0tTqAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "zRJ2":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "zkds":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zmmJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"sobre"}},[_c('b-row',{staticClass:"tituloPaginaRow",style:(_vm.tituloRowBG)},[_c('h1',{staticClass:"tituloPagina"},[_vm._v("\n      "+_vm._s(_vm.tituloPagina)+"\n    ")])]),_vm._v(" "),_c('b-row',{staticClass:"p-3 p-sm-0 p-md-0 p-lg-0 p-xl-0"},[_c('p',{class:_vm.justifiedText,domProps:{"innerHTML":_vm._s(_vm.textoSobre)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.cd84c4b802dd8413641c.js